import {setTimeout} from "timers";
import {setTimeout} from "timers";
<template>
  <v-card class="backgroundForEventDetails"
          v-if="eventDetails.Type === 'Rental'"
          v-resize="onResize">
    <!--    if mobile phone is active the bottom nav-->
    <v-bottom-nav
      v-if="$store.getters.getMobilePhoneActive"
      fixed
      :active.sync="activeBtn"
      :value="showNav"
      color="primary"
      style="height: 100px !important;"
    >
      <v-layout justify-center align-center>
        <div>
          <v-bottom-sheet v-model="sheet">
            <template v-slot:activator>
              <v-layout justify-space-between>
                <v-icon color="white">expand_less</v-icon>
                <v-btn flat color="teal">
                  <h2 style="color: white;">{{$translate('SHOPPINGCART')}} ({{shoppingCartTotal}})</h2>
                  <v-icon
                    large
                    color="white">shopping_cart
                  </v-icon>
                </v-btn>
                <v-icon color="white">expand_less</v-icon>
              </v-layout>
            </template>

            <v-card class="shoppingBagMobile" elevation="5">
              <v-card class="shoppingCartTitle"
                      :style="`border-bottom: 0.3em solid ${$vuetify.theme.primary};`">
                <v-layout justify-center align-center column fill-height>
                  <h3 :style="`color: ${$vuetify.theme.primary}`">
                    {{$translate('SHOPPINGCART')}} ({{shoppingCartTotal}})
                  </h3>
                </v-layout>
              </v-card>
              <v-card class="v-card--flat shoppingBagContent">
                <v-list v-if="shoppingCart.length > 0" two-line>
                  <template v-for="(item, index) in shoppingCart">
                    <v-list-tile
                      :key="item.Id"
                      avatar
                    >
                      <v-list-tile-avatar tile>
                        <v-img contain :aspect-ratio="16/9" :src="item.Picture"/>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{item.Name}}</v-list-tile-title>
                        <v-list-tile-sub-title v-if="eventDetails.Type !== 'Repetitive'
                        && eventDetails.Type !== 'Tour'
                        && eventDetails.Type !== 'Fixed'">
                          {{$translate('AMOUNT')}}: {{item.Amount}}
                          , {{$translate('PRICE2')}}: €{{roundPrice(item.Price)}}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title v-else>
                          {{$translate('AMOUNT')}}: {{item.Amount}}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="item.hasOwnProperty('ItemDefs')">
                          <template v-for="(selected, categories) in item.ItemDefs">
                            <b>{{categories}}:</b> <i>{{selected}} </i>
                          </template>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-layout row>
                          <v-btn v-on:click.stop="item.Amount--, checkTickets(item)"
                                 fab
                                 dark
                                 class="plusOrMinusButtonShoppingCart"
                                 small
                                 color="primary">
                            <v-icon dark>remove</v-icon>
                          </v-btn>
                          <p style="padding: 0 0.5em !important;">
                            {{item.Amount > 0 ? item.Amount : item.Amount = 0}}</p>
                          <v-btn v-on:click.stop="checkTickets(item, true)"
                                 class="plusOrMinusButtonShoppingCart"
                                 fab
                                 dark
                                 small
                                 color="primary">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider class="dividerStyle"></v-divider>
                  </template>
                </v-list>
                <v-card v-else class="v-card--flat">
                  <v-layout justify-center align-center fill-height column>
                    <h3>{{$translate('SHOPPINGCART_EMPTY')}}</h3>
                    <v-icon large>shopping_cart</v-icon>
                  </v-layout>
                </v-card>
              </v-card>
              <v-card class="shoppingCartTitle"
                      style="padding: 0 3em;"
                      :color="$vuetify.theme.primary"
                      dark>
                <v-layout align-center
                          justify-space-between
                          row
                          fill-height
                          v-if="eventDetails.Type !== 'Repetitive'
                          && eventDetails.Type !== 'Tour'
                          && eventDetails.Type !== 'Fixed'">
                  <h3>{{$translate('TOTAL')}}:</h3>
                  <h1>€{{totalPrice}}</h1>
                </v-layout>
              </v-card>
              <v-card class="shoppingCartTitle v-card--flat">
                <v-layout align-center justify-center row fill-height>
                  <v-btn
                    @click="LoginCheckAndRemoveSheet()"
                    round
                    medium
                    :disabled="shoppingCart.length === 0"
                    color="primary">
                    {{$translate('ORDER_NOW')}}
                  </v-btn>
                </v-layout>
              </v-card>
            </v-card>

          </v-bottom-sheet>
        </div>
      </v-layout>
    </v-bottom-nav>
    <v-card class="v-card--flat containerDetails">
      <v-img
        v-if="eventDetails.PictureUrl !== 'NULL'"
        aspect-ratio="1"
        class="eventImage"
        :src="eventDetails.PictureUrl"
      />
    </v-card>
    <!--    When using a mobile phone-->
    <v-layout v-if="$store.getters.getMobilePhoneActive"
              justify-center
              align-start
              row
              wrap>
      <v-card class="midSectionDetails pt-4 v-card--flat">
        <v-layout v-if="productFlow" row wrap>
          <v-flex xs12>
            <v-layout column wrap>
              <v-flex xs12>
                <v-flex xs12>
                  <v-layout align-center>
                    <v-btn
                      color="primary"
                      round
                      large
                      @click="goToEventHomepage()"
                    >
                      {{$translate('BACK')}}
                    </v-btn>
                  </v-layout>
                  <v-layout row wrap>
                    <template>
                      <v-card :color="switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                              :dark="switchContent"
                              @click="switchContent = true;
                            getBarChart(formatDate(new Date().toISOString().slice(0, 10)),
                             'myChart')"
                              class="toggleProducts">
                        <v-layout justify-center align-center column fill-height>
                          <v-icon>event</v-icon>
                          <h4><b>{{$translate('DETAILS')}}</b></h4>
                        </v-layout>
                      </v-card>
                    </template>
                    <v-card :color="!switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                            :dark="!switchContent"
                            @click="switchContent = false"
                            class="toggleProducts">
                      <v-layout justify-center align-center column fill-height>
                        <v-icon>ti-ticket</v-icon>
                        <h4><b>{{$translate('OPTIONS')}}</b></h4>
                      </v-layout>
                    </v-card>
                  </v-layout>
                </v-flex>
                <v-card v-if="switchContent"
                        @click="getBarChart(this.formatDate(this.selectedDate),
                        'myChart')"
                        class="toggleContent v-card--flat">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <h1
                        class="eventTitleMobile"
                        :style="`color: ${$vuetify.theme.primary}`"
                      >{{eventDetails.EventTranslationName}}</h1>
                      <v-spacer></v-spacer>
                      <v-flex xs12>
                        <v-card ref="descriptionOfTheEvent"
                                class="v-card--flat descriptionV-card">
                          <v-layout align-center
                                    justify-space-between
                                    row>
                            <h2 :style="`color: ${$vuetify.theme.primary}`"
                                class="eventDescriptionTitleMobile"
                            >{{$translate('DESCRIPTION')}}</h2>
                            <v-layout column>
                              <v-icon
                                class="favoriteIcon"
                                :color="eventDetails.Favourite ? 'red' : 'grey'"
                                x-large
                                @click="toggleFavourite(eventDetails)"
                              >favorite
                              </v-icon>
                              <p class="favoriteText">
                                {{eventDetails.Favourite ? $translate('FAVORITE')
                                : $translate('ADD_FAVORITE')}}
                              </p>
                            </v-layout>
                          </v-layout>
                          <p class="sizeableDescription" v-html="returnRightDescription()"></p>
                        </v-card>
                      </v-flex>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">
                        {{$translate('EVENT_GRAPH_DETAILS')}}
                      </h2>
                      <v-layout
                        row
                        justify-space-between
                        wrap
                      >
                        <v-flex class="ml-4" xs3>
                          <v-menu
                            ref="menu3"
                            :close-on-content-click="true"
                            v-model="menu3"
                            :nudge-right="40"
                            :return-value.sync="selectedDate"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="computedDateFormattedSelectedDate"
                              :label="$translate('EVENT_GRAPH_DATE_PICKER')"
                              hide-details
                              append-icon="event"
                              readonly
                            ></v-text-field>
                            <v-date-picker
                              first-day-of-week="1"
                              :allowed-dates="allowedPossibleDatesList"
                              :events="allowedPossibleDatesList"
                              @change="getBarChart(formatDate(selectedDate), 'myChart')"
                              color="primary"
                              v-model="selectedDate"
                              @input="$refs.menu3.save(selectedDate)"
                              no-title
                            />
                          </v-menu>
                        </v-flex>
                        <v-flex xs3>
                          <v-select
                            @change="getStartDates(true)"
                            :items="Object.values(allLocations)"
                            v-model="chosenLocation"
                            item-text="LocationName"
                            return-object
                            persistent-hint
                            :label="$translate('CHOOSE_A_LOCATION')">
                          </v-select>
                        </v-flex>
                      </v-layout>
                      <v-flex xs12>
                        <v-layout justify-center>
                          <canvas id="myChart"></canvas>
                        </v-layout>
                        <h1 class="noData"
                            v-if="noData
                            && !noPlanBoardData">
                          {{$translate('NO_BOOKINGS_YET')}}
                        </h1>
                      </v-flex>
                      <v-flex xs12 class="photoCarousel">
                        <v-card class="elevation-0 transparent">
                          <v-carousel height="325"
                                      :cycle="extraPictures.length === 1 ? false : true"
                                      hide-controls>
                            <v-carousel-item v-for="(photo,key) in extraPictures"
                                             :key="key"
                                             :src="photo"/>
                          </v-carousel>
                        </v-card>
                      </v-flex>
                      <v-flex xs12>
                        <v-card class="eventInfo elevation-0 transparent">
                          <v-card class="v-card--flat contactV-card" ref="contactForTheEvent">
                            <h2
                              v-if="Object.keys(eventDetails.Suggestions).length > 0"
                              class="pa-3"
                            >{{$translate('SUGGESTIONS')}}</h2>
                            <v-list three-line v-if="Object.keys(eventDetails.Suggestions).length > 0">
                              <template v-for="(item, index) in eventDetails.Suggestions">
                                <v-list-tile
                                  :key="index"
                                  avatar
                                >
                                  <v-list-tile-avatar>
                                    <img v-if="item.Picture !== ''"
                                         :src="item.Picture">
                                    <img v-else
                                         src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content>
                                    <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      {{setTruncatedDescription(item.Description)}}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                  <v-list-tile-action>
                                    <v-icon
                                      class="hoverElement"
                                      @click="goToNewEvent(index)">
                                      keyboard_arrow_right
                                    </v-icon>
                                  </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                              </template>
                            </v-list>
                            <h2
                              v-if="Object.keys(eventDetails.Alternatives).length > 0"
                              class="pa-3"
                            >{{$translate('EVENT_ALTERNATIVES')}}</h2>
                            <v-list three-line v-if="Object.keys(eventDetails.Alternatives).length >0">
                              <template v-for="(item, index) in eventDetails.Alternatives">
                                <v-list-tile
                                  :key="index"
                                  avatar
                                >
                                  <v-list-tile-avatar>
                                    <img v-if="item.Picture !== ''"
                                         :src="item.Picture">
                                    <img v-else
                                         src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content>
                                    <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      {{setTruncatedDescription(item.Description)}}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                  <v-list-tile-action>
                                    <v-icon
                                      class="hoverElement"
                                      @click="goToNewEvent(index)">
                                      keyboard_arrow_right
                                    </v-icon>
                                  </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                              </template>
                            </v-list>
                            <h1 :style="`color: ${$vuetify.theme.primary}`">
                              {{$translate('EVENT_INFO')}}
                            </h1>
                            <v-flex xs12 style="margin-bottom: 1em;">
                              <v-layout column>
                                <v-flex xs12>
                                  <p>
                                    <b>{{$translate('AVA_DAYS')}}:</b>
                                  </p>
                                </v-flex>
                                <v-flex xs12 v-if="eventDetails.hasOwnProperty('BatchGroupInfo')">
                                  <template v-for="(item, index) in eventDetails.BatchGroupInfo.Days">
                                    <p style="margin: 0;">{{returnRightDay(item)}}</p>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <p>
                              <b>{{$translate('OPEN_HOURS')}}:</b>
                              {{eventDetails.BatchGroupInfo.Times}}
                            </p>
                            <p v-if="eventDetails.BatchGroupInfo.Price !== -1">
                              <b>{{$translate('PRICE')}}:</b>
                              {{eventDetails.BatchGroupInfo.Price}} Euro
                            </p>
                          </v-card>
                          <v-card v-if="eventDetails.Type === 'Rental'"
                                  class="v-card--flat locationV-card"
                                  ref="locationOfTheEvent">
                            <h1 :style="`color: ${$vuetify.theme.primary}`">
                              {{$translate('PRICE_OVERVIEW')}}
                            </h1>
                            <v-layout column>
                              <template v-for="(item, index) in batchGroupList">
                                <v-card class="priceOverviewBlocks v-card--flat"
                                        style="padding-right: 0 !important;">
                                  <v-layout column>
                                    <v-flex xs12>
                                      <h3>{{item.Name}}</h3>
                                      <p v-if="item.hasOwnProperty('StartDate')">
                                        <b>{{$translate('STARTDATE')}}:</b> {{item.StartDate}}</p>
                                      <p v-if="item.hasOwnProperty('EndDate')">
                                        <b>{{$translate('ENDDATE')}}:</b> {{item.EndDate}}</p>
                                    </v-flex>
                                    <v-flex xs12>
                                      <v-layout row>
                                        <v-flex xs12>
                                          <v-layout column justify-start align-start fill-height>
                                            <p><b>{{$translate('PRICE_PERCENTAGE')}}:</b>
                                              {{returnPercentageOfPrice(item.PricePercentage)}}
                                            </p>
                                            <p><i>{{$translate('PERCENTAGE_EXPLANATION')}}</i></p>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                  <hr class="hrForPrices">
                                </v-card>
                              </template>
                            </v-layout>
                          </v-card>
                        </v-card>
                        <v-flex xs12>
                          <Reviews :eventDetails="eventDetails"></Reviews>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
                <v-card v-else class="toggleContent v-card--flat">
                  <v-flex v-if="Object.values(products.Categories).length !== 0"
                          xs12>
                    <v-select
                      :items="Object.values(products.Categories)"
                      item-text="Name"
                      :label="$translate('PRODUCT_CATEGORY')"
                      v-model="chosenCategorie"
                    ></v-select>
                  </v-flex>
                  <v-card v-if="priceCategoriesOrProducts" class="v-card--flat">
                    <template
                      v-if="chosenCategorie === '' ? true
                      : Object.values(item.Categories).indexOf(chosenCategorie) !== -1"
                      class="productStyling"
                      v-for="(item,index) in products.Products"
                    >
                      <v-card :key="index" class="mb-3">
                        <v-flex xs12 style="width: 100%;">
                          <v-layout row>
                            <v-flex xs4>
                              <v-img :src="item.PictureUrl" contain :aspect-ratio="16/9"></v-img>
                            </v-flex>
                            <!--                          If item has selection options-->
                            <v-flex xs8>
                              <v-flex xs12>
                                <p style="color: red;"
                                   v-if="item.Id == foundProductInSearch.ParentId
                                    && foundProductInSearch.Capacity == 0">
                                  {{$translate('OUT_OF_STOCK')}}
                                </p>
                              </v-flex>
                              <v-layout v-if="Object.entries(item.ItemDef).length > 0" column>
                                <v-flex xs12 style="margin-left: 1em;">
                                  <h3>{{item.Name}}</h3>
                                  <p class="productPrice">{{pricePrefix}}{{roundPrice(item.Price)}}</p>
                                </v-flex>
                                <v-flex xs12>
                                  <v-flex xs12>
                                    <v-layout column>
                                      <template v-for="(innerItem, innerIndex) in item.ItemDef">
                                        <v-select :items="Object.values(innerItem)"
                                                  v-model="item.ChosenProduct[innerIndex]"
                                                  item-text="TotalTime"
                                                  return-object
                                                  persistent-hint
                                                  :label="innerIndex"
                                                  @change="checkForProduct(item)"
                                                  @click.native.stop>
                                        </v-select>
                                      </template>
                                      <v-btn
                                        :disabled="item.Id == foundProductInSearch.ParentId
                                        && foundProductInSearch.Capacity > 0 ? false : true"
                                        v-on:click.stop="item.DisabledButton = false,
                                        searchForProduct(item)"
                                        round
                                        small
                                        color="primary">
                                        {{$translate('ADD')}}
                                      </v-btn>
                                    </v-layout>
                                  </v-flex>
                                </v-flex>
                              </v-layout>
                              <div v-else>
                                <v-layout column>
                                  <v-flex xs8 v-if="Object.entries(item.ItemDef).length < 1">
                                    <v-layout column>
                                      <v-flex xs12>
                                        <h3>{{item.Name}}</h3>
                                        <p class="productPrice">{{pricePrefix}}{{roundPrice(item.Price)}}</p>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex v-if="Object.entries(item.ItemDef).length < 1"
                                          xs4
                                          class="buttonGroup">
                                    <v-layout row>
                                      <v-btn v-on:click.stop="item.Amount--,
                                      checkTickets(item)"
                                             fab
                                             dark
                                             class="plusOrMinusButton"
                                             small
                                             color="secondary">
                                        <v-icon dark>remove</v-icon>
                                      </v-btn>
                                      <h1>{{item.Amount > 0 ? item.Amount : item.Amount = 0}}</h1>
                                      <v-btn v-on:click.stop="item.ForAge > 17 ? acceptAge(item)
                                      : checkTickets(item, true)"
                                             class="plusOrMinusButton"
                                             fab
                                             dark
                                             small
                                             color="secondary">
                                        <v-icon dark>add</v-icon>
                                      </v-btn>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-card-text>
                          <h3>{{$translate('PRODUCT_INFO')}}</h3>
                          <p class="mb-2">{{item.Description}}</p>
                          <h3 v-if="item.hasOwnProperty('PriceCategories')">
                            {{$translate('AVAILABLE_PRICES')}}
                          </h3>
                          <v-layout v-for="(PriceCategorie, index) in item.PriceCategories"
                                    :key="index">
                            <p>{{PriceCategorie.Description}}: €{{PriceCategorie.Price}}</p>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-card>
                  <div class="text-xs-center">
                    <v-dialog
                      v-model="forAgeAbove17"
                      width="500">
                      <v-card>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title>
                          {{$translate('WARNING')}}
                        </v-card-title>
                        <v-card-text>
                          {{$translate('EVENT_FORAGE_MESSAGE')}}
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="secondary"
                            round
                            @click="forAgeAbove17 = false">
                            {{$translate('CLOSE')}}
                          </v-btn>
                          <v-btn
                            color="primary"
                            round
                            @click="checkTickets(forAgeAbove17Product, true)">
                            {{$translate('ACCEPT')}}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4 v-if="!$store.getters.getMobilePhoneActive">
            <v-card class="shoppingBag" elevation="5">
              <v-card class="shoppingCartTitle"
                      :style="`border-bottom: 0.3em solid ${$vuetify.theme.primary};`">
                <v-layout justify-center align-center column fill-height>
                  <h3 :style="`color: ${$vuetify.theme.primary}`">
                    {{$translate('SHOPPINGCART')}} ({{shoppingCartTotal}})
                  </h3>
                </v-layout>
              </v-card>
              <v-card class="v-card--flat shoppingBagContent">
                <v-list v-if="shoppingCart.length > 0" two-line>
                  <template v-for="(item, index) in shoppingCart">
                    <v-list-tile
                      :key="item.Id"
                      avatar>
                      <v-list-tile-avatar tile>
                        <v-img contain :aspect-ratio="16/9" :src="item.PictureUrl"/>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.Name}}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{$translate('AMOUNT')}}: {{item.Amount}}
                          , {{$translate('PRICE2')}}: €{{roundPrice(item.Price)}}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="item.hasOwnProperty('ItemDefs')">
                          <template v-for="(selected, categorie) in item.ItemDefs">
                            <b>{{categorie}}:</b> <i>{{selected}} </i></template>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-layout row>
                          <v-btn v-on:click.stop="item.Amount--, checkTickets(item)"
                                 fab
                                 dark
                                 class="plusOrMinusButtonShoppingCart"
                                 small
                                 color="primary">
                            <v-icon dark>remove</v-icon>
                          </v-btn>
                          <p style="padding: 0 0.5em !important;">
                            {{item.Amount > 0 ? item.Amount : item.Amount = 0}}
                          </p>
                          <v-btn v-on:click.stop="checkTickets(item, true)"
                                 class="plusOrMinusButtonShoppingCart"
                                 fab
                                 dark
                                 small
                                 color="primary">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider class="dividerStyle"/>
                  </template>
                </v-list>
                <v-card v-else class="v-card--flat">
                  <v-layout justify-center align-center fill-height column>
                    <h3>{{$translate('SHOPPINGCART_EMPTY')}}</h3>
                    <v-icon large>shopping_cart</v-icon>
                  </v-layout>
                </v-card>
              </v-card>
              <v-card class="shoppingCartTitle"
                      style="padding: 0 3em;"
                      :color="$vuetify.theme.primary"
                      dark>
                <v-layout align-center justify-space-between row fill-height>
                  <h3>{{$translate('TOTAL')}}:</h3>
                  <h1>€{{totalPrice}}</h1>
                </v-layout>
              </v-card>
              <v-card class="shoppingCartTitle v-card--flat">
                <v-layout align-center justify-center row fill-height>
                  <v-btn
                    @click="checkIfUserIsLoggedIn()"
                    round
                    medium
                    :disabled="shoppingCart.length == 0"
                    color="primary">
                    {{$translate('ORDER_NOW')}}
                  </v-btn>
                </v-layout>
              </v-card>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap>
          <v-flex xs12>
            <v-layout column wrap>
              <v-flex xs12 class="secondSection">
                <v-card class="toggleContent v-card--flat">
                  <v-flex xs12 v-if="stepperSteps == 1">
                    <v-flex xs12>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">
                        <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                                style="width: 2.5em !important;">
                          <p style="color: white;
                          margin: 0 !important;
                          margin-left: -0.4em !important;">1/2</p>
                        </v-chip>
                        {{$translate('USER_SELECTIONS')}}
                      </h2>
                      <v-flex xs12 class="searchBarFlex">
                        <p>{{$translate('SELECTED_DATA_EXPLANATION')}}</p>
                        <v-layout align-center justify-center mt-2>
                          <v-card class="rounded-card rentalInputDates v-card--flat">
                            <v-layout row wrap>
                              <v-card style="width: 100%;" class="sizeForSearchBlock v-card--flat">
                                <v-layout row justify-space-between>
                                  <v-flex xs5>
                                    <v-select v-if="DeliveryOrTakeawayItems.length != 0"
                                              :items="DeliveryOrTakeawayItems"
                                              persistent-hint
                                              @change="getStartDates(true)"
                                              :disabled="DeliveryOrTakeawayDisabled"
                                              v-model="DeliveryOrTakeaway"
                                              :label="$translate('SELECT_ORDERTYPE')"></v-select>
                                  </v-flex>
                                  <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                                    <v-select
                                      :items="Object.values(tickets)"
                                      @change="checkForBookButton()"
                                      v-model="DeliveryDistance"
                                      item-text="Name"
                                      return-object
                                      persistent-hint
                                      :label="$translate('DELIVERY_DISTANCE')"></v-select>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                              <v-card style="width: 100%;" class="sizeForSearchBlock v-card--flat">
                                <v-flex xs12>
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        ref="menu1"
                                        :close-on-content-click="true"
                                        v-model="menu1"
                                        :nudge-right="40"
                                        :return-value.sync="chosenStartDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                        :disabled="allowedStartDate.length === 1"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedStartDate.length === 1
                                          || DeliveryOrTakeaway === ''"
                                          v-model="computedDateFormattedStartDate"
                                          :label="allowedStartDate.length === 1  ? $translate('STARTDATE'):
                                          $translate('PLEASE_STARTTIME')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :allowed-dates="allowedStartDates"
                                          :events="allowedStartDates"
                                          first-day-of-week="1"
                                          @change="callingSecondFunctionForRentalBar(1)"
                                          color="primary"
                                          v-model="chosenStartDate"
                                          @input="$refs.menu1.save(chosenStartDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="callingSecondFunctionForRentalBar(2)"
                                                :disabled="Object.values(rentalStartTimes).length === 1"
                                                :items="Object.values(rentalStartTimes)"
                                                v-model="rentalStartTime"
                                                return-object
                                                persistent-hint
                                                :label="Object.values(rentalStartTimes).length === 1
                                                ? $translate('CALENDAR_EVENT_STARTTIME')
                                                : $translate('PLEASE_STARTTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row
                                                        align-center
                                                        justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>
                                                  {{data.item.StartTime
                                                  + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus',data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em;
                                                          transform: scale(0.8);">
                                                    {{$translate(getChipData('text', data.item))}}
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 v-if="eventDetails.Type === 'Rental'">
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        :disabled="rentalStartTime == ''"
                                        ref="menu2"
                                        :close-on-content-click="true"
                                        v-model="menu2"
                                        :nudge-right="40"
                                        :return-value.sync="chosenEndDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedEndDate.length === 1"
                                          v-model="computedDateFormattedEndDate"
                                          :label="rentalStartTime == '' ? '' : $translate('PLEASE_ENDDATE')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :disabled="allowedEndDate.length === 1"
                                          :events="allowedEndDates"
                                          :allowed-dates="allowedEndDates"
                                          first-day-of-week="1"
                                          color="primary"
                                          v-model="chosenEndDate"
                                          @change="callingSecondFunctionForRentalBar(3)"
                                          @input="$refs.menu2.save(chosenEndDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="checkForBookButton()"
                                                :disabled="Object.values(rentalEndTimes).length === 1"
                                                :items="Object.values(rentalEndTimes)"
                                                v-model="rentalEndTime"
                                                return-object
                                                persistent-hint
                                                :label="chosenEndDate == '' ? '': $translate('PLEASE_ENDTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>{{data.item.StartTime + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus', data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em;  width: 2.7em !important;   transform: scale(0.8);">
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-card>
                            </v-layout>
                          </v-card>
                        </v-layout>
                      </v-flex>
                      <p
                        v-if="DeliveryDistance.hasOwnProperty('Price') && DeliveryDistance.FreeThreshold > totalPrice || DeliveryDistance.FreeThreshold == -1">
                        {{$translate('SELECT_THIS')}} <b>€{{DeliveryDistance.Price}}</b> {{$translate('DELIVERY_FEE')}}
                      </p>
                      <p
                        v-if="DeliveryDistance.hasOwnProperty('FreeThreshold') && DeliveryDistance.FreeThreshold - totalPrice > 0">
                        {{$translate('OR_ORDER_FOR')}} <b>€{{roundPrice(DeliveryDistance.FreeThreshold -
                        totalPrice)}}</b> {{$translate('MORE_PRODUCTS')}}</p>
                    </v-flex>
                    <h2 :style="`color: ${$vuetify.theme.primary}`">
                      <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                              style="width: 2.5em !important;">
                        <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">2/2</p>
                      </v-chip>
                      {{$translate('ENTER_YOUR_PERSONAL_DETAILS')}}
                    </h2>
                    <p>{{$translate('PERSONAL_DETAILS_EXPLANATION')}}</p>
                    <v-layout row wrap justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('FIRSTNAME')"
                          v-model="userInputs[11]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('LASTNAME')"
                          v-model="userInputs[12]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('STREET')"
                          v-model="userInputs[14]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('INCIDENT_NUMMER')"
                          v-model="userInputs[15]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('CITY')"
                          v-model="userInputs[17]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('PHONE_NR')"
                          v-model="userInputs[19]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-textarea
                          :label="$translate('REMARK_OPTIONAL')"
                          auto-grow
                          no-resize
                          rows="1"
                          v-model="remark"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="checkbox"
                        :label="$translate('SAVE_DETAILS')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row justify-space-between>
                        <v-btn
                          round
                          medium
                          color="secondary"
                          @click="goBackToDetailsFlow()"
                        >
                          {{$translate('BACK')}}
                        </v-btn>
                        <v-btn
                          round
                          medium
                          :disabled="bookButton || loading"
                          color="primary"
                          @click="bookBatch()"
                        >
                          {{$translate('CONTINUE')}}
                        </v-btn>
                      </v-layout>
                      <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="primary"
                        class="loadingBar"
                      ></v-progress-linear>
                      <div class="text-xs-center">
                        <v-dialog
                          v-model="locationNotFound"
                          width="500"
                        >
                          <v-card>
                            <v-card-title
                              class="headline grey lighten-2"
                              primary-title
                            >
                              {{$translate('USER_LOCATION_NOT_FOUND')}}
                            </v-card-title>
                            <v-card-text>
                              {{$translate('USER_LOCATION_NOT_FOUND_DESC')}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                flat
                                @click="locationNotFound = false">
                                {{$translate('CLOSE')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 v-if="stepperSteps == 2">
                    <h1 :style="`color: ${$vuetify.theme.primary}`">
                      {{$translate('CONFIRM_YOUR_CHOICES')}}
                    </h1>
                    <p style="font-size: 18px">
                      {{$translate('CONFIRM_YOUR_CHOICES_EXPLANATION')}}
                    </p>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{$translate('USER_DETAILS')}}:</h2>
                        <p v-if="userDetails.hasOwnProperty('Name')"
                           class="adressStyling">
                          <b>{{$translate('NAME')}}</b>: {{userDetails.Name}}</p>
                        <p v-if="userDetails.hasOwnProperty('PhoneNumber')"
                           class="adressStyling">
                          <b>{{$translate('PHONE_NR')}}</b>: {{userDetails.PhoneNumber}}</p>
                        <p v-if="DeliveryOrTakeaway === 'Delivery'"
                           class="adressStyling">
                          <b>{{$translate('STREET')}}</b>: {{userDetails.Street}}</p>
                        <p v-if="DeliveryOrTakeaway === 'Delivery'"
                           class="adressStyling">
                          <b>{{$translate('INCIDENT_NUMMER')}}</b>: {{userDetails.Nr}}</p>
                        <p v-if="DeliveryOrTakeaway === 'Delivery'"
                           class="adressStyling">
                          <b>{{$translate('CITY')}}</b>: {{userDetails.City}}</p>
                        <p v-if="this.remark !== ''"><b>{{$translate('REMARK')}}</b>: {{this.remark}}</p>
                        <h2 class="paddingForTitle">{{$translate('USER_SELECTIONS')}}:</h2>
                        <p v-if="DeliveryOrTakeawayItems.length != 0" class="adressStyling"><b>{{$translate('ORDER_TYPE')}}</b>:
                          {{DeliveryOrTakeaway}}</p>
                        <p v-if="chosenStartDate !== ''"
                           class="adressStyling">
                          <b>{{$translate('STARTDATE')}}</b>: {{chosenStartDate.split('-').reverse().join('-')}}</p>
                        <p v-if="chosenEndDate !== ''"
                           class="adressStyling">
                          <b>{{$translate('ENDDATE')}}</b>: {{chosenEndDate.split('-').reverse().join('-')}}</p>
                        <p v-if="rentalStartTime.hasOwnProperty('StartTime')"
                           class="adressStyling">
                          <b>{{$translate('LINDA_STARTTIME')}}</b>:
                          {{rentalStartTime.StartTime}} - {{rentalStartTime.EndTime}}</p>
                        <p v-if="rentalEndTime !== undefined && rentalEndTime.hasOwnProperty('StartTime')"
                           class="adressStyling">
                          <b>{{$translate('LINDA_ENDTIME')}}</b>:
                          {{rentalEndTime.StartTime}} - {{rentalEndTime.EndTime}}</p>
                      </v-flex>
                      <v-list v-if="eventDetails.Type !== 'Rental' && eventDetails.Type != 'FlexEvent'"
                              style="width: 100%; !important; padding-top: 0;" two-line>
                        <h2>{{$translate('YOUR_ORDER')}}:</h2>
                        <template v-for="(item, index) in userOrder.Order">
                          <v-list-tile
                            v-if="item.OrderItemType != 'DeliveryCost'"
                            class="orderListItem"
                            :key="item.Id"
                            avatar
                          >
                            <v-list-tile-avatar size="100" class="orderListAvatar" tile>
                              <v-img contain :aspect-ratio="16/9" :src="item.Picture"/>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                              <v-list-tile-title>{{eventDetails.Type == 'Fixed' ? item.PriceCategoryName :
                                item.ProductName}} {{item.Aspects}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title style="color: black;">
                                <v-layout row justify-end><b>{{item.hasOwnProperty('GroupSize') ? item.GroupSize :
                                  item.Quantity}}x €{{eventDetails.Type == 'Fixed' || eventDetails.Type == 'Repetitive'
                                  ? roundPrice(item.PriceCategoryPrice) : roundPrice(item.ItemPrice)}}</b></v-layout>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="dividerStyle"></v-divider>
                        </template>
                        <v-layout align-end justify-start column fill-height>
                          <h3 style="padding-right: 1em;"
                              v-if="totalPrice !== userOrder.OrderTotalPrice && DeliveryOrTakeaway == 'Delivery'">
                            {{$translate('EX_DELIVERY_FEE')}} : €{{roundPrice(userOrder.OrderTotalPrice -
                            DeliveryDistance.Price)}}</h3>
                          <h3 class="freeDelivery"
                              v-else-if="totalPrice == userOrder.OrderTotalPrice && DeliveryOrTakeaway == 'Delivery'">
                            {{$translate('FREE_DELIVERY')}} </h3>
                          <h2 style="padding-right: 0.7em;">{{$translate('TOTAL')}}: €{{userOrder.OrderTotalPrice}}</h2>
                        </v-layout>
                      </v-list>
                      <v-list v-else style="width: 100%; !important; padding-top: 0;" two-line>
                        <h2>{{$translate('YOUR_ORDER')}}:</h2>
                        <template
                          v-for="(item, index) in userOrder.hasOwnProperty('Products') ? userOrder.Products : userOrder.Tickets">
                          <v-card
                            v-if="eventDetails.Type == 'Rental'"
                            class="orderListItem"
                            :key="index"
                          >
                            <v-card-title>{{item.Name}}
                              <v-btn class="no-click" v-if="item.State === 'Available'" round color="green">
                                {{item.State}}
                              </v-btn>
                              <v-btn class="no-click" v-else round color="red">{{item.State}}</v-btn>
                            </v-card-title>
                            <v-card-text>
                              <v-layout row justify-end><b>{{item.Quantity}}x €{{roundPrice( item.Price)}}</b>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                          <v-list-tile
                            v-else
                            class="orderListItem"
                            :key="index"
                            avatar
                          >
                            <v-list-tile-content>
                              <v-list-tile-title><b>{{item.Name}}</b></v-list-tile-title>
                              <v-list-tile-sub-title>{{item.Description}}</v-list-tile-sub-title>
                              <v-list-tile-sub-title style="color: black;">
                                <v-layout row justify-end><b>{{item.Amount}}x €{{roundPrice(item.Price)}}</b></v-layout>
                              </v-list-tile-sub-title>

                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="dividerStyle"></v-divider>
                        </template>
                        <v-layout align-end justify-start column fill-height>
                          <h2 style="padding-right: 0.7em;">{{$translate('TOTAL')}}: €{{userOrder.OrderTotalPrice}}</h2>
                        </v-layout>
                      </v-list>
                      <div class="text-xs-center">
                        <v-dialog
                          v-model="notAllAvaiblable"
                          width="500"
                        >
                          <v-card>
                            <v-card-title
                              class="headline grey lighten-2"
                              primary-title
                            >
                              {{$translate('UNAVAILABLE')}}
                            </v-card-title>
                            <v-card-text>
                              {{$translate('UNAVAILABLE_TEXT')}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                round
                                color="secondary"
                                @click="notAllAvaiblable = false"
                              >
                                {{$translate('CANCEL')}}
                              </v-btn>
                              <v-btn
                                round
                                color="primary"
                                @click="confirmOrderLoading()"
                              >
                                {{$translate('ACCEPT')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                      <v-flex xs12>
                        <v-layout row justify-space-between>
                          <v-btn
                            round
                            medium
                            color="secondary"
                            @click="cancelOrder()"
                          >
                            {{$translate('BACK')}}
                          </v-btn>
                          <v-btn
                            round
                            medium
                            color="primary"
                            @click="checkProductStatesBeforeConfirm()"
                          >
                            {{$translate('CONFIRM')}}
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>

            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-layout>
    <v-layout v-else justify-center align-start row wrap>
      <v-card class="midSectionDetails pt-4 v-card--flat">
        <v-layout v-if="productFlow" row wrap>
          <v-flex xs8>
            <v-layout column wrap>
              <v-flex xs12>
                <v-layout align-start>
                  <v-btn
                    color="primary"
                    round
                    class="backButtonActivityDetails"
                    large
                    @click="goToEventHomepage()">
                    {{$translate('BACK')}}
                  </v-btn>
                </v-layout>
                <v-layout row wrap>
                  <template>
                    <v-card :color="switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                            :dark="switchContent"
                            @click="switchContent = true;
                            getBarChart(formatDate(new Date().toISOString().slice(0, 10)), 'myChart')"
                            class="toggleProducts">
                      <v-layout justify-center align-center column fill-height>
                        <v-icon>event</v-icon>
                        <h4><b>{{$translate('DETAILS')}}</b></h4>
                      </v-layout>
                    </v-card>
                  </template>
                  <v-card :color="!switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                          :dark="!switchContent"
                          @click="switchContent = false"
                          class="toggleProducts">
                    <v-layout justify-center align-center column fill-height>
                      <v-icon>ti-ticket</v-icon>
                      <h4><b>{{$translate('OPTIONS')}}</b></h4>
                    </v-layout>
                  </v-card>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-card v-if="switchContent" class="toggleContent v-card--flat">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <h1
                        :style="`color: ${$vuetify.theme.primary}`"
                        class="eventTitle"
                      >{{eventDetails.EventTranslationName}}</h1>
                      <v-spacer></v-spacer>
                      <v-layout column>
                        <v-icon
                          class="favoriteIcon"
                          :color="eventDetails.Favourite ? 'red' : 'grey'"
                          x-large
                          @click="toggleFavourite(eventDetails)"
                        >favorite
                        </v-icon>
                        <p class="favoriteText">
                          {{eventDetails.Favourite ? $translate('FAVORITE') : $translate('ADD_FAVORITE')}}
                        </p>
                      </v-layout>
                      <v-flex xs12>
                        <v-card ref="descriptionOfTheEvent" class="v-card--flat descriptionV-card">
                          <h1
                            :style="`color: ${$vuetify.theme.primary}`"
                            class="eventDescriptionTitle"
                          >{{$translate('DESCRIPTION')}}</h1>
                          <p class="eventDescription" v-html="returnRightDescription()"></p>
                        </v-card>
                      </v-flex>
                      <v-flex xs4>
                        <v-card class="eventInfo elevation-0 transparent">
                          <v-card class="v-card--flat contactV-card" ref="contactForTheEvent">
                            <h2
                              v-if="Object.keys(eventDetails.Suggestions).length > 0"
                              class="pa-3"
                            >{{$translate('SUGGESTIONS')}}</h2>
                            <v-list three-line v-if="Object.keys(eventDetails.Suggestions).length > 0">
                              <template v-for="(item, index) in eventDetails.Suggestions">
                                <v-list-tile
                                  :key="index"
                                  avatar
                                >
                                  <v-list-tile-avatar>
                                    <img v-if="item.Picture !== ''"
                                         :src="item.Picture">
                                    <img v-else
                                         src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content>
                                    <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      {{setTruncatedDescription(item.Description)}}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                  <v-list-tile-action>
                                    <v-icon
                                      class="hoverElement"
                                      @click="goToNewEvent(index)">
                                      keyboard_arrow_right
                                    </v-icon>
                                  </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                              </template>
                            </v-list>
                            <h2
                              v-if="Object.keys(eventDetails.Alternatives).length > 0"
                              class="pa-3"
                            >{{$translate('EVENT_ALTERNATIVES')}}</h2>
                            <v-list three-line v-if="Object.keys(eventDetails.Alternatives).length >0">
                              <template v-for="(item, index) in eventDetails.Alternatives">
                                <v-list-tile
                                  :key="index"
                                  avatar
                                >
                                  <v-list-tile-avatar>
                                    <img v-if="item.Picture !== ''"
                                         :src="item.Picture">
                                    <img v-else
                                         src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content>
                                    <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      {{setTruncatedDescription(item.Description)}}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                  <v-list-tile-action>
                                    <v-icon
                                      class="hoverElement"
                                      @click="goToNewEvent(index)">
                                      keyboard_arrow_right
                                    </v-icon>
                                  </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                              </template>
                            </v-list>
                            <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_INFO')}}</h1>
                            <v-flex xs12 style="margin-bottom: 1em;">
                              <v-layout row>
                                <v-flex xs6>
                                  <p>
                                    <b>{{$translate('AVA_DAYS')}}:</b>
                                  </p>
                                </v-flex>
                                <v-flex xs6 v-if="eventDetails.hasOwnProperty('BatchGroupInfo')">
                                  <template v-for="(item, index) in eventDetails.BatchGroupInfo.Days">
                                    <p style="margin: 0;">{{returnRightDay(item)}}</p>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <p>
                              <b>{{$translate('OPEN_HOURS')}}:</b>
                              {{eventDetails.BatchGroupInfo.Times}}
                            </p>
                            <p v-if="eventDetails.BatchGroupInfo.Price !== -1">
                              <b>{{$translate('PRICE')}}:</b>
                              {{eventDetails.BatchGroupInfo.Price}} Euro
                            </p>
                          </v-card>
                        </v-card>
                      </v-flex>
                      <v-flex xs7 class="photoCarousel">
                        <v-card class="elevation-0 transparent">
                          <v-carousel height="325"
                                      :cycle="extraPictures.length === 1 ? false : true"
                                      hide-controls>
                            <v-carousel-item v-for="(photo,key) in extraPictures"
                                             :key="key"
                                             :src="photo"></v-carousel-item>
                          </v-carousel>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-card v-if="eventDetails.Type === 'Rental'"
                            class="v-card--flat locationV-card"
                            ref="locationOfTheEvent">
                      <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('PRICE_OVERVIEW')}}</h1>
                      <v-layout column>
                        <template v-for="(item, index) in batchGroupList">
                          <v-card class="priceOverviewBlocks v-card--flat">
                            <v-layout row>
                              <v-flex xs6>
                                <h3>{{item.Name}}</h3>
                                <p v-if="item.hasOwnProperty('StartDate')">
                                  <b>{{$translate('STARTDATE')}}:</b> {{item.StartDate}}
                                </p>
                                <p v-if="item.hasOwnProperty('EndDate')">
                                  <b>{{$translate('ENDDATE')}}:</b> {{item.EndDate}}
                                </p>
                              </v-flex>
                              <v-flex xs6>
                                <v-layout row>
                                  <v-flex xs6>
                                    <v-layout column justify-start align-start fill-height>
                                      <p>
                                        <b>{{$translate('PRICE_PERCENTAGE')}}:</b>
                                        {{returnPercentageOfPrice(item.PricePercentage)}}
                                      </p>
                                      <p><i>{{$translate('PERCENTAGE_EXPLANATION')}}</i></p>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <hr class="hrForPrices">
                          </v-card>
                        </template>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <h1 :style="`color: ${$vuetify.theme.primary}`">
                    {{$translate('EVENT_GRAPH_DETAILS')}}
                  </h1>
                  <v-layout row
                            justify-space-between
                            wrap>
                    <v-flex class="ml-4" xs3>
                      <v-menu
                        ref="menu3"
                        :close-on-content-click="true"
                        v-model="menu3"
                        :nudge-right="40"
                        :return-value.sync="selectedDate"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="computedDateFormattedSelectedDate"
                          :label="$translate('EVENT_GRAPH_DATE_PICKER')"
                          hide-details
                          append-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          first-day-of-week="1"
                          :allowed-dates="allowedPossibleDatesList"
                          :events="allowedPossibleDatesList"
                          @change="getBarChart(formatDate(selectedDate), 'myChart')"
                          color="primary"
                          v-model="selectedDate"
                          @input="$refs.menu3.save(selectedDate)"
                          no-title
                        />
                      </v-menu>
                    </v-flex>
                    <v-flex xs3>
                      <v-select
                        @change="getStartDates(false)"
                        :items="Object.values(allLocations)"
                        v-model="chosenLocation"
                        item-text="LocationName"
                        return-object
                        persistent-hint
                        :label="$translate('CHOOSE_A_LOCATION')">s
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12>
                    <v-layout justify-center>
                      <canvas id="myChart"></canvas>
                    </v-layout>
                    <h1 class="noData" v-if="noData && !noPlanBoardData">{{$translate('NO_BOOKINGS_YET')}}</h1>
                  </v-flex>
                  <v-flex xs12>
                    <Reviews :eventDetails="eventDetails"></Reviews>
                  </v-flex>
                </v-card>
                <v-card v-else class="toggleContent v-card--flat">
                  <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('PRODUCT_BELOW_EXPLANATION')}}</h3>
                  <v-flex xs12 v-if="Object.values(products.Categories).length !== 0">
                    <v-layout row
                              justify-center>
                      <v-btn fab
                             @click="page !== 0 ? page-- : page = 0"
                             color="primary"
                             :disabled="page !== 0 ? false : true"
                             v-if="products.hasOwnProperty('Categories')"
                             small
                             icon>
                        <v-icon>keyboard_arrow_left</v-icon>
                      </v-btn>
                      <template v-for="(item, index) in allCategories[page]">
                        <div @click="chosenCategorie = item.Name"
                             class="categoryBlock"
                             :style=" `background-color: ${chosenCategorie === item.Name ? $vuetify.theme.secondary : 'white'}`">
                          <v-layout row
                                    justify-center
                                    align-center
                                    fill-height>
                            <h3>{{item.Name}}</h3>
                          </v-layout>
                        </div>
                      </template>
                      <v-btn fab
                             color="primary"
                             v-if="products.hasOwnProperty('Categories')"
                             small
                             :disabled="page !== allCategories.length-1 ? false : true"
                             @click="page !== allCategories.length-1 ? page++ : page = allCategories.length-1"
                             icon>
                        <v-icon>keyboard_arrow_right</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                  <v-list v-if="priceCategoriesOrProducts" three-line>
                    <template
                      v-if="chosenCategorie === '' ? true : Object.values(item.Categories).indexOf(chosenCategorie) !== -1"
                      class="productStyling"
                      v-for="(item,index) in products.Products">
                      <v-list-tile :key="index">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <h3>{{item.Name}}</h3>
                          </v-flex>
                          <v-flex xs2>
                            <v-img :src="item.PictureUrl"
                                   :lazy-src="item.Picture"
                                   contain
                                   :aspect-ratio="16/9"/>
                          </v-flex>
                          <v-flex xs10>
                            <div>
                              <v-layout row>
                                <v-flex xs8 style="margin-left: 1em;" v-if="Object.entries(item.ItemDef).length < 1">
                                  <p v-if="Object.values(item.Items).length === 1"
                                     class="productPrice">
                                    {{pricePrefix}}{{roundPrice(item.Price)}}
                                  </p>
                                  <p v-else-if="!item.hasOwnProperty('SelectionPrice')"
                                     class="productPrice">
                                    {{$translate('PRICE_STARTING_AT')}}: {{pricePrefix}}{{roundPrice(item.LowestPrice)}}
                                  </p>
                                  <p v-else>
                                    {{pricePrefix}}{{roundPrice(item.SelectionPrice)}}
                                  </p>
                                </v-flex>
                                <v-flex xs4 v-else>
                                  <p v-if="Object.values(item.Items).length === 1"
                                     class="productPrice">
                                    {{pricePrefix}}{{roundPrice(item.Price)}}
                                  </p>
                                  <p v-else-if="!item.hasOwnProperty('SelectionPrice')"
                                     class="productPrice">
                                    {{$translate('PRICE_STARTING_AT')}}: {{pricePrefix}}{{roundPrice(item.LowestPrice)}}
                                  </p>
                                  <p v-else>
                                    {{pricePrefix}}{{roundPrice(item.SelectionPrice)}}
                                  </p>
                                </v-flex>
                                <v-flex v-if="Object.entries(item.ItemDef).length < 1 && item.Capacity !== 0"
                                        xs4
                                        class="buttonGroup">
                                  <v-layout row>
                                    <v-btn
                                      v-on:click.stop="item.Amount !== 0 ? item.Amount-- : item.Amount = 0; checkTickets(item)"
                                      fab
                                      dark
                                      class="plusOrMinusButton"
                                      small
                                      color="secondary">
                                      <v-icon dark>remove</v-icon>
                                    </v-btn>
                                    <h1>{{item.Amount > 0 ? item.Amount : item.Amount = 0}}</h1>
                                    <v-btn
                                      v-on:click.stop="item.ForAge > 17 ? acceptAge(item) : checkTickets(item, true)"
                                      class="plusOrMinusButton"
                                      fab
                                      dark
                                      small
                                      color="secondary">
                                      <v-icon dark>add</v-icon>
                                    </v-btn>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-else-if="Object.entries(item.ItemDef).length > 0" xs8>
                                  <v-layout row>
                                    <template v-for="(innerItem, innerIndex) in item.ItemDef">
                                      <v-select :items="Object.values(innerItem)"
                                                v-model="item.ChosenProduct[innerIndex]"
                                                item-text="TotalTime"
                                                return-object
                                                persistent-hint
                                                :label="innerIndex"
                                                @change="checkForProduct(item)"
                                                @click.native.stop>
                                      </v-select>
                                    </template>
                                    <v-btn
                                      v-if="item.DisabledButton"
                                      :disabled="item.Id == foundProductInSearch.ParentId && foundProductInSearch.Capacity > 0 ? false : true"
                                      v-on:click.stop="item.DisabledButton = false; searchForProduct(item)"
                                      round
                                      medium
                                      color="primary">
                                      {{$translate('ADD')}}
                                    </v-btn>
                                    <v-btn
                                      v-else
                                      v-on:click.stop="searchForProduct(item)"
                                      round
                                      medium
                                      color="primary">
                                      {{$translate('ADD')}}
                                    </v-btn>
                                  </v-layout>
                                  <v-flex xs12>
                                    <p style="color: red;"
                                       v-if="item.Id == foundProductInSearch.ParentId &&
                                    foundProductInSearch.Capacity == 0">{{$translate('OUT_OF_STOCK')}}</p>
                                  </v-flex>
                                </v-flex>
                                <v-flex v-else>
                                  <v-layout row
                                            justify-center
                                            align-center
                                            fill-height>
                                    <p style="color: red;">{{$translate('OUT_OF_STOCK')}}</p>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-card class="v-card--flat">
                        <v-card-text>
                          <h3>{{$translate('PRODUCT_INFO')}}</h3>
                          <p class="mb-2">{{item.Description}}</p>
                          <h3 v-if="item.hasOwnProperty('PriceCategories')">{{$translate('AVAILABLE_PRICES')}}</h3>
                          <v-layout v-for="(PriceCategorie, index) in item.PriceCategories" :key="index">
                            <p>{{PriceCategorie.Description}}: €{{PriceCategorie.Price}}</p>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                      <v-flex xs12>
                        <v-divider class="dividerStyle"></v-divider>
                      </v-flex>
                    </template>
                  </v-list>
                  <div class="text-xs-center">
                    <v-dialog
                      v-model="forAgeAbove17"
                      width="500"
                    >
                      <v-card>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                        >
                          {{$translate('WARNING')}}
                        </v-card-title>
                        <v-card-text>
                          {{$translate('EVENT_FORAGE_MESSAGE')}}
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="secondary"
                            round
                            @click="forAgeAbove17 = false"
                          >
                            {{$translate('CLOSE')}}
                          </v-btn>
                          <v-btn
                            color="primary"
                            round
                            @click="checkTickets(forAgeAbove17Product, true)"
                          >
                            {{$translate('ACCEPT')}}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-card class="shoppingBag" elevation="5">
              <v-card class="shoppingCartTitle" :style="`border-bottom: 0.3em solid ${$vuetify.theme.primary};`">
                <v-layout justify-center align-center column fill-height>
                  <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('SHOPPINGCART')}}
                    ({{shoppingCartTotal}})</h3>
                </v-layout>
              </v-card>
              <v-card class="v-card--flat shoppingBagContent">
                <v-list v-if="shoppingCart.length > 0" two-line>
                  <template v-for="(item, index) in shoppingCart">
                    <v-list-tile
                      :key="item.Id"
                      avatar
                    >
                      <v-list-tile-avatar tile>
                        <v-img contain :aspect-ratio="16/9" :src="item.PictureUrl"/>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{item.Name}}</v-list-tile-title>
                        <v-list-tile-sub-title v-if="eventDetails.Type !== 'Rental' && eventDetails.Type != 'Fixed'">
                          {{$translate('AMOUNT')}}: {{item.Amount}}, {{$translate('PRICE2')}}
                          €{{roundPrice(item.Price)}}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title v-else> {{$translate('AMOUNT')}}: {{item.Amount}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="item.hasOwnProperty('ItemDefs')">
                          <template v-for="(selected, categorie) in item.ItemDefs"><b>{{categorie}}:</b>
                            <i>{{selected}} </i></template>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-layout row>
                          <v-btn v-on:click.stop="item.Amount--; checkTickets(item)" fab dark
                                 class="plusOrMinusButtonShoppingCart" small color="primary">
                            <v-icon dark>remove</v-icon>
                          </v-btn>
                          <p style="padding: 0 0.5em !important;">{{item.Amount > 0 ? item.Amount : item.Amount =
                            0}}</p>
                          <v-btn v-on:click.stop="checkTickets(item, true)" class="plusOrMinusButtonShoppingCart" fab
                                 dark small color="primary">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider class="dividerStyle"></v-divider>
                  </template>
                </v-list>
                <v-card v-else class="v-card--flat">
                  <v-layout justify-center align-center fill-height column>
                    <h3>{{$translate('SHOPPINGCART_EMPTY')}}</h3>
                    <v-icon large>shopping_cart</v-icon>
                  </v-layout>
                </v-card>
              </v-card>
              <v-card class="shoppingCartTitle" style="padding: 0 3em;" :color="$vuetify.theme.primary" dark>
                <v-layout align-center justify-space-between row fill-height>
                </v-layout>
              </v-card>
              <v-card class="shoppingCartTitle v-card--flat">
                <v-layout align-center justify-center row fill-height>
                  <v-btn
                    @click="closeMap()"
                    round
                    medium
                    :disabled="shoppingCart.length == 0"
                    color="primary">
                    {{$translate('ORDER_NOW')}}
                  </v-btn>
                </v-layout>
              </v-card>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap>
          <v-flex xs12>
            <v-layout column wrap>
              <v-flex xs12 class="secondSection">
                <v-card class="toggleContent v-card--flat">
                  <v-flex xs12 v-if="stepperSteps == 1">
                    <v-flex xs12>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">
                        <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                                style="width: 2.5em !important;">
                          <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">1/2</p>
                        </v-chip>
                        {{$translate('USER_SELECTIONS')}}
                      </h2>
                      <v-flex xs12 class="searchBarFlex">
                        <p>{{$translate('SELECTED_DATA_EXPLANATION')}}</p>
                        <v-layout align-center justify-center mt-2>
                          <v-card class="rounded-card rentalInputDates v-card--flat">
                            <v-layout row wrap>
                              <v-card style="width: 100%;" class="sizeForSearchBlock v-card--flat">
                                <v-layout row wrap justify-space-between>
                                  <v-flex xs5>
                                    <v-select
                                      @change="getStartDates(true)"
                                      :items="Object.values(allLocations)"
                                      v-model="chosenLocation"
                                      item-text="LocationName"
                                      return-object
                                      persistent-hint
                                      :label="$translate('CHOOSE_A_LOCATION')">
                                    </v-select>
                                  </v-flex>
                                  <v-flex xs5>
                                    <v-select v-if="DeliveryOrTakeawayItems.length != 0"
                                              :items="DeliveryOrTakeawayItems"
                                              persistent-hint
                                              @change="getStartDates(true)"
                                              :disabled="DeliveryOrTakeawayDisabled"
                                              v-model="DeliveryOrTakeaway"
                                              persistent-hint
                                              :label="$translate('SELECT_ORDERTYPE')"></v-select>
                                  </v-flex>
                                  <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                                    <v-select
                                      :items="Object.values(tickets)"
                                      @change="checkForBookButton()"
                                      v-model="DeliveryDistance"
                                      item-text="Name"
                                      return-object
                                      persistent-hint
                                      :label="$translate('DELIVERY_DISTANCE')"></v-select>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                              <v-card style="width: 100%;" class="sizeForSearchBlock v-card--flat">
                                <v-flex xs12>
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        ref="menu1"
                                        :close-on-content-click="true"
                                        v-model="menu1"
                                        :nudge-right="40"
                                        :return-value.sync="chosenStartDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                        :disabled="allowedStartDate.length === 1"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedStartDate.length === 1 || DeliveryOrTakeaway === ''"
                                          v-model="computedDateFormattedStartDate"
                                          :label="allowedStartDate.length === 1  ? $translate('STARTDATE'): $translate('PLEASE_STARTTIME')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :allowed-dates="allowedStartDates"
                                          :events="allowedStartDates"
                                          first-day-of-week="1"
                                          @change="callingSecondFunctionForRentalBar(1)"
                                          color="primary"
                                          v-model="chosenStartDate"
                                          @input="$refs.menu1.save(chosenStartDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="callingSecondFunctionForRentalBar(2)"
                                                :disabled="Object.values(rentalStartTimes).length === 1"
                                                :items="Object.values(rentalStartTimes)"
                                                v-model="rentalStartTime"
                                                return-object
                                                persistent-hint
                                                :label="Object.values(rentalStartTimes).length === 1 ? $translate('CALENDAR_EVENT_STARTTIME'): $translate('PLEASE_STARTTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>{{data.item.StartTime + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus', data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em; transform: scale(0.8);">
                                                    {{$translate(getChipData('text', data.item))}}
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 v-if="eventDetails.Type === 'Rental'">
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        :disabled="rentalStartTime == ''"
                                        ref="menu2"
                                        :close-on-content-click="true"
                                        v-model="menu2"
                                        :nudge-right="40"
                                        :return-value.sync="chosenEndDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedEndDate.length === 1"
                                          v-model="computedDateFormattedEndDate"
                                          :label="rentalStartTime == '' ? '' : $translate('PLEASE_ENDDATE')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :disabled="allowedEndDate.length === 1"
                                          :events="allowedEndDates"
                                          :allowed-dates="allowedEndDates"
                                          first-day-of-week="1"
                                          color="primary"
                                          v-model="chosenEndDate"
                                          @change="callingSecondFunctionForRentalBar(3)"
                                          @input="$refs.menu2.save(chosenEndDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="checkForBookButton()"
                                                :disabled="Object.values(rentalEndTimes).length === 1"
                                                :items="Object.values(rentalEndTimes)"
                                                v-model="rentalEndTime"
                                                return-object
                                                persistent-hint
                                                :label="Object.values(rentalEndTimes).length === 1 ? $translate('CALENDAR_EVENT_ENDTIME'): $translate('PLEASE_ENDTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>{{data.item.StartTime + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus', data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em;  width: 2.7em !important;   transform: scale(0.8);">
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-card>
                            </v-layout>
                          </v-card>
                        </v-layout>
                      </v-flex>
                      <p
                        v-if="DeliveryDistance.hasOwnProperty('Price')
                        && DeliveryDistance.FreeThreshold > totalPrice
                        || DeliveryDistance.FreeThreshold === -1"
                      >
                        {{$translate('SELECT_THIS')}}
                        <b>€{{DeliveryDistance.Price}}</b>
                        {{$translate('DELIVERY_FEE')}}
                      </p>
                      <p
                        v-if="DeliveryDistance.hasOwnProperty('FreeThreshold')
                        && DeliveryDistance.FreeThreshold - totalPrice > 0"
                      >
                        {{$translate('OR_ORDER_FOR')}}
                        <b>€{{roundPrice(DeliveryDistance.FreeThreshold - totalPrice)}}</b>
                        {{$translate('MORE_PRODUCTS')}}
                      </p>
                    </v-flex>
                    <h2 :style="`color: ${$vuetify.theme.primary}`">
                      <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                              style="width: 2.5em !important;">
                        <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">2/2</p>
                      </v-chip>
                      {{$translate('ENTER_YOUR_PERSONAL_DETAILS')}}
                    </h2>
                    <p>{{$translate('PERSONAL_DETAILS_EXPLANATION')}}</p>
                    <v-layout row wrap justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('FIRSTNAME')"
                          v-model="userInputs[11]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('LASTNAME')"
                          v-model="userInputs[12]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('STREET')"
                          v-model="userInputs[14]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('INCIDENT_NUMMER')"
                          v-model="userInputs[15]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 v-if="DeliveryOrTakeaway === 'Delivery'">
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('CITY')"
                          v-model="userInputs[17]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('PHONE_NR')"
                          v-model="userInputs[19]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-textarea
                          :label="$translate('REMARK_OPTIONAL')"
                          auto-grow
                          no-resize
                          rows="1"
                          v-model="remark"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs5>
                        <v-checkbox
                          v-model="checkbox"
                          :label="$translate('SAVE_DETAILS')"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <v-layout row justify-space-between>
                        <v-btn
                          round
                          medium
                          color="secondary"
                          @click="goBackToDetailsFlow()"
                        >
                          {{$translate('BACK')}}
                        </v-btn>
                        <v-btn
                          round
                          medium
                          :disabled="bookButton || loading"
                          color="primary"
                          @click="bookBatch()"
                        >
                          {{$translate('CONTINUE')}}
                        </v-btn>
                      </v-layout>
                      <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="primary"
                        class="loadingBar"
                      ></v-progress-linear>
                      <div class="text-xs-center">
                        <v-dialog
                          v-model="locationNotFound"
                          width="500"
                        >
                          <v-card>
                            <v-card-title
                              class="headline grey lighten-2"
                              primary-title
                            >
                              {{$translate('USER_LOCATION_NOT_FOUND')}}
                            </v-card-title>
                            <v-card-text>
                              {{$translate('USER_LOCATION_NOT_FOUND_DESC')}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                flat
                                @click="locationNotFound = false">
                                {{$translate('CLOSE')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 v-if="stepperSteps == 2">
                    <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('CONFIRM_YOUR_CHOICES')}}</h1>
                    <p style="font-size: 18px">{{$translate('CONFIRM_YOUR_CHOICES_EXPLANATION')}}</p>
                    <v-layout row wrap>
                      <v-list style="width: 100%; !important; padding-top: 0;" two-line>
                        <h2>{{$translate('YOUR_ORDER')}}:</h2>
                        <template v-for="(item, index) in userOrder.Order">
                          <v-list-tile
                            v-if="item.OrderItemType != 'DeliveryCost'"
                            class="orderListItem"
                            :key="item.Id"
                            avatar
                          >
                            <v-list-tile-avatar size="100" class="orderListAvatar" tile>
                              <v-img contain :aspect-ratio="16/9" :src="item.Picture"/>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                              <v-card class="v-card--flat" style="width: 100%;">
                                <v-layout row>
                                  <v-flex xs8>
                                    <v-list-tile-title><b>{{item.ProductName == '' ? item.PriceCategoryName :
                                      item.ProductName}} {{item.Aspects}}</b></v-list-tile-title>
                                    <v-list-tile-sub-title>{{item.PriceCategoryDescription}}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title>€{{roundPrice(item.ItemPrice)}}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title>{{$translate('QUANTITY')}}: <b>{{item.Quantity}}</b>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-list-tile-sub-title style="color: black;">
                                      <v-layout row justify-end><b>{{$translate('SUBTOTAL')}}:
                                        €{{roundPrice(item.Quantity * item.ItemPrice)}}</b></v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="dividerStyle"></v-divider>
                        </template>
                        <v-layout align-end justify-start column fill-height>
                          <h3 style="padding-right: 1em;"
                              v-if="totalPrice !== userOrder.OrderTotalPrice && DeliveryOrTakeaway == 'Delivery'">
                            {{$translate('EX_DELIVERY_FEE')}} : €{{roundPrice(userOrder.OrderTotalPrice -
                            DeliveryDistance.Price)}}</h3>
                          <h3 class="freeDelivery"
                              v-else-if="totalPrice == userOrder.OrderTotalPrice && DeliveryOrTakeaway == 'Delivery'">
                            {{$translate('FREE_DELIVERY')}} </h3>
                          <h2 style="padding-right: 0.7em;">{{$translate('TOTAL')}}: €{{userOrder.OrderTotalPrice}}</h2>
                        </v-layout>
                      </v-list>
                      <v-flex xs12>
                        <v-layout row justify-space-between>
                          <v-flex xs5>
                            <h2 style="margin-bottom: 1em;" :style="`color: ${$vuetify.theme.primary}`">
                              {{$translate('USER_DETAILS')}}:</h2>
                            <v-layout row>
                              <v-flex xs6>
                                <p v-if="userDetails.hasOwnProperty('Name')" class="adressStyling"><b>{{$translate('NAME')}}</b>:
                                </p>
                                <p v-if="userDetails.hasOwnProperty('PhoneNumber')" class="adressStyling"><b>{{$translate('PHONE_NR')}}</b>:
                                </p>
                                <p v-if="DeliveryOrTakeaway === 'Delivery'" class="adressStyling"><b>{{$translate('STREET')}}</b>:
                                </p>
                                <p v-if="DeliveryOrTakeaway === 'Delivery'" class="adressStyling"><b>{{$translate('INCIDENT_NUMMER')}}</b>:
                                </p>
                                <p v-if="DeliveryOrTakeaway === 'Delivery'" class="adressStyling"><b>{{$translate('CITY')}}</b>:
                                </p>
                                <p v-if="this.remark !== ''"><b>{{$translate('REMARK')}}</b>:</p>
                              </v-flex>
                              <v-flex xs6>
                                <p v-if="userDetails.hasOwnProperty('Name')" class="adressStyling">
                                  {{userDetails.Name}}</p>
                                <p v-if="userDetails.hasOwnProperty('PhoneNumber')" class="adressStyling">
                                  {{userDetails.PhoneNumber}}</p>
                                <p v-if="DeliveryOrTakeaway === 'Delivery'" class="adressStyling">
                                  {{userDetails.Street}}</p>
                                <p v-if="DeliveryOrTakeaway === 'Delivery'" class="adressStyling">{{userDetails.Nr}}</p>
                                <p v-if="DeliveryOrTakeaway === 'Delivery'" class="adressStyling">
                                  {{userDetails.City}}</p>
                                <p v-if="this.remark !== ''">{{this.remark}}</p>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs5>
                            <h2 style="margin-bottom: 1em;" :style="`color: ${$vuetify.theme.primary}`">
                              {{$translate('USER_SELECTIONS')}}:</h2>
                            <v-layout row>
                              <v-flex xs6>
                                <p v-if="DeliveryOrTakeawayItems.length != 0" class="adressStyling"><b>{{$translate('ORDER_TYPE')}}</b>:
                                </p>
                                <p v-if="chosenStartDate !== ''"
                                   class="adressStyling">
                                  <b>{{$translate('STARTDATE')}}</b>:</p>
                                <p v-if="chosenEndDate !== ''"
                                   class="adressStyling">
                                  <b>{{$translate('ENDDATE')}}</b>:</p>
                                <p v-if="rentalStartTime.hasOwnProperty('StartTime')"
                                   class="adressStyling">
                                  <b>{{$translate('LINDA_STARTTIME')}}</b>:</p>
                                <p v-if="rentalEndTime !== undefined && rentalEndTime.hasOwnProperty('StartTime')"
                                   class="adressStyling">
                                  <b>{{$translate('LINDA_ENDTIME')}}</b>:</p>
                              </v-flex>
                              <v-flex xs6>
                                <p v-if="DeliveryOrTakeawayItems.length != 0" class="adressStyling">
                                  {{DeliveryOrTakeaway}}</p>
                                <p v-if="chosenStartDate !== ''"
                                   class="adressStyling">
                                  {{chosenStartDate.split('-').reverse().join('-')}}</p>
                                <p v-if="chosenEndDate !== ''"
                                   class="adressStyling">
                                  {{chosenEndDate.split('-').reverse().join('-')}}</p>
                                <p v-if="rentalStartTime.hasOwnProperty('StartTime')"
                                   class="adressStyling">
                                  {{rentalStartTime.StartTime}} - {{rentalStartTime.EndTime}}</p>
                                <p v-if="rentalEndTime !== undefined && rentalEndTime.hasOwnProperty('StartTime')"
                                   class="adressStyling">
                                  {{rentalEndTime.StartTime}} - {{rentalEndTime.EndTime}}</p>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <div class="text-xs-center">
                        <v-dialog
                          v-model="notAllAvaiblable"
                          width="500"
                        >
                          <v-card>
                            <v-card-title
                              class="headline grey lighten-2"
                              primary-title
                            >
                              {{$translate('UNAVAILABLE')}}
                            </v-card-title>
                            <v-card-text>
                              {{$translate('UNAVAILABLE_TEXT')}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                round
                                color="secondary"
                                @click="notAllAvaiblable = false"
                              >
                                {{$translate('CANCEL')}}
                              </v-btn>
                              <v-btn
                                round
                                color="primary"
                                @click="confirmOrderLoading()"
                              >
                                {{$translate('ACCEPT')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                      <v-flex xs12>
                        <v-layout row justify-space-between>
                          <v-btn
                            round
                            medium
                            color="secondary"
                            @click="cancelOrder()"
                          >
                            {{$translate('BACK')}}
                          </v-btn>
                          <v-btn
                            round
                            medium
                            color="primary"
                            @click="checkProductStatesBeforeConfirm()"
                          >
                            {{$translate('CONFIRM')}}
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>

            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-layout>
    <v-card v-if="showMap" style="margin: 0 1.5em;" class="mapForHomepageMobile v-card--flat">
      <Map ref="activityDetailMapWebShop"
           v-if="eventDetails.Type === 'Rental'"
           :settings="mapSettingsWebShop"></Map>
    </v-card>
  </v-card>
  <v-card v-else class="detailsContainer" v-resize="onResize">
    <v-flex xs12 v-if="productFlow && $store.getters.getMobilePhoneActive">
      <v-layout column>
        <v-flex xs12>
          <v-carousel hide-controls
                      :cycle="extraPictures.length === 1 ? false : true"
                      hide-delimiters
                      height="50vh">
            <v-carousel-item v-for="(photo,key) in extraPictures" :key="key" :src="photo"></v-carousel-item>
          </v-carousel>
        </v-flex>
        <div class="responsiveContainer">
          <v-flex xs12 style="background-color: white; height: 100%;">
            <v-flex>
              <v-layout column justify-center fill-height>
                <div>
                  <v-layout align-end justify-start row fill-height>
                    <v-btn
                      color="primary"
                      round
                      class="btnback"
                      large
                      @click="goToEventHomepage()"
                    >
                      {{$translate('BACK')}}
                    </v-btn>
                  </v-layout>
                  <v-layout row wrap>
                    <h1
                      :style="`color: ${$vuetify.theme.primary}`"
                    >{{eventDetails.EventTranslationName}}</h1>
                    <v-spacer></v-spacer>
                    <v-layout column>
                      <v-icon
                        class="favoriteIcon"
                        :color="eventDetails.Favourite ? 'red' : 'grey'"
                        x-large
                        @click="toggleFavourite(eventDetails)"
                      >favorite
                      </v-icon>
                      <p class="favoriteText">
                        {{eventDetails.Favourite ? $translate('FAVORITE') : $translate('ADD_FAVORITE')}}
                      </p>
                    </v-layout>
                  </v-layout>
                  <div :style="`background-color: ${$vuetify.theme.secondary}`" style="height: 0.5em;"></div>
                  <v-card class="v-card--flat">
                    <v-flex xs12>
                      <v-card ref="descriptionOfTheEvent" class="v-card--flat descriptionV-card">
                        <p style="font-size: 20px;" v-html="returnRightDescription()"></p>
                      </v-card>
                    </v-flex>
                  </v-card>
                  <v-flex xs12>
                    <div>
                      <v-btn
                        :disabled="possibleDatesList.length === 0 && eventDetails.Type !== 'External'"
                        style="margin-bottom: 3em !important;"
                        @click="goToProductFlow()"
                        round
                        x-large
                        color="primary"
                      >
                        <h2>{{$translate('BOOK')}}
                          <v-icon>arrow_forward_ios</v-icon>
                        </h2>
                      </v-btn>
                    </div>
                  </v-flex>
                </div>
              </v-layout>
            </v-flex>
          </v-flex>
          <v-flex xs12 style="background-color: white; height: 100%;">
            <v-flex xs12 class="flexLeftBottom">
              <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_GRAPH_DETAILS')}}</h1>
              <v-layout row
                        justify-space-between
                        wrap>
                <v-flex xs5>
                  <v-menu
                    ref="menu3"
                    :close-on-content-click="true"
                    v-model="menu3"
                    :nudge-right="40"
                    :return-value.sync="selectedDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="computedDateFormattedSelectedDate"
                      :label="$translate('EVENT_GRAPH_DATE_PICKER')"
                      hide-details
                      append-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      first-day-of-week="1"
                      @change="getBarChart(formatDate(selectedDate), 'myChart')"
                      color="primary"
                      v-model="selectedDate"
                      @input="$refs.menu3.save(selectedDate)"
                      no-title
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs5>
                  <v-select
                    @change="getStartDates(false)"
                    :items="Object.values(allLocations)"
                    v-model="chosenLocation"
                    item-text="LocationName"
                    return-object
                    persistent-hint
                    :label="$translate('CHOOSE_A_LOCATION')">s
                  </v-select>
                </v-flex>
              </v-layout>
              <v-flex xs12>
                <v-layout justify-center>
                  <div class="chart-container">
                    <canvas id="myChart" style="height: 20em !important;"></canvas>
                  </div>
                </v-layout>
                <h1 class="noData" v-if="noData && !noPlanBoardData">{{$translate('NO_BOOKINGS_YET')}}</h1>
              </v-flex>
            </v-flex>
          </v-flex>
        </div>
        <v-layout ref="InfoSection" style="width: 80% !important; margin: 0 auto;">
          <v-card class="v-card--flat" style="margin: 0 auto;">
            <v-flex xs12>
              <v-card class="eventInfo elevation-0 transparent">
                <v-card class="v-card--flat contactV-card" ref="contactForTheEvent">
                  <h2
                    v-if="Object.keys(eventDetails.Suggestions).length > 0"
                    class="pa-3"
                  >{{$translate('SUGGESTIONS')}}</h2>
                  <v-list three-line v-if="Object.keys(eventDetails.Suggestions).length > 0">
                    <template v-for="(item, index) in eventDetails.Suggestions">
                      <v-list-tile
                        :key="index"
                        avatar
                      >
                        <v-list-tile-avatar>
                          <img v-if="item.Picture !== ''"
                               :src="item.Picture">
                          <img v-else
                               src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                          <v-list-tile-sub-title>
                            {{setTruncatedDescription(item.Description)}}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-icon
                            class="hoverElement"
                            @click="goToNewEvent(index)">
                            keyboard_arrow_right
                          </v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                  <h2
                    v-if="Object.keys(eventDetails.Alternatives).length > 0"
                    class="pa-3"
                  >{{$translate('EVENT_ALTERNATIVES')}}</h2>
                  <v-list three-line v-if="Object.keys(eventDetails.Alternatives).length >0">
                    <template v-for="(item, index) in eventDetails.Alternatives">
                      <v-list-tile
                        :key="index"
                        avatar
                      >
                        <v-list-tile-avatar>
                          <img v-if="item.Picture !== ''"
                               :src="item.Picture">
                          <img v-else
                               src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                          <v-list-tile-sub-title>
                            {{setTruncatedDescription(item.Description)}}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-icon
                            class="hoverElement"
                            @click="goToNewEvent(index)">
                            keyboard_arrow_right
                          </v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                  <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_INFO')}}</h1>
                  <div :style="`background-color: ${$vuetify.theme.secondary}`" class="lineUnderTitle"></div>
                  <v-flex xs12 style="margin-bottom: 1em;">
                    <v-layout row justify>
                      <v-flex xs6>
                        <p>
                          <b>{{$translate('AVA_DAYS')}}:</b>
                        </p>
                      </v-flex>
                      <v-flex xs6 v-if="eventDetails.hasOwnProperty('BatchGroupInfo')">
                        <v-layout column>
                          <template v-for="(item, index) in eventDetails.BatchGroupInfo.Days">
                            <p style="margin: 0;">{{returnRightDay(item)}}&nbsp </p>
                          </template>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <p>
                    <b>{{$translate('OPEN_HOURS')}}:</b>
                    {{eventDetails.BatchGroupInfo.Times}}
                  </p>
                  <p v-if="eventDetails.BatchGroupInfo.Price !== -1">
                    <b>{{$translate('PRICE')}}:</b>
                    {{eventDetails.BatchGroupInfo.Price}} Euro
                  </p>
                </v-card>
              </v-card>
            </v-flex>
            <v-card v-if="eventDetails.Type === 'Rental'" class="v-card--flat locationV-card" ref="locationOfTheEvent">
              <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('PRICE_OVERVIEW')}}</h1>
              <div :style="`background-color: ${$vuetify.theme.secondary}`" class="lineUnderTitle"></div>
              <v-layout column>
                <template v-for="(item, index) in batchGroupList">
                  <v-card class="priceOverviewBlocks v-card--flat">
                    <v-layout row justify-space-between>
                      <v-flex xs5>
                        <h3>{{item.Name}}</h3>
                        <p v-if="item.hasOwnProperty('StartDate')"><b>{{$translate('STARTDATE')}}:</b>
                          {{item.StartDate}}</p>
                        <p v-if="item.hasOwnProperty('EndDate')"><b>{{$translate('ENDDATE')}}:</b> {{item.EndDate}}</p>
                      </v-flex>
                      <v-flex xs5>
                        <v-layout row>
                          <v-flex xs12>
                            <v-layout column justify-start align-start fill-height>
                              <p><b>{{$translate('PRICE_PERCENTAGE')}}:</b>
                                {{returnPercentageOfPrice(item.PricePercentage)}}</p>
                              <p><i>{{$translate('PERCENTAGE_EXPLANATION')}}</i></p>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <hr class="hrForPrices">
                  </v-card>
                </template>
              </v-layout>
              <v-flex xs12>
                <Reviews :eventDetails="eventDetails"></Reviews>
              </v-flex>
            </v-card>
          </v-card>
        </v-layout>
        <div style="margin: auto; width: 80%; margin-bottom: 6em !important;">
          <Map ref="activityDetailMapWebShop"
               v-if="eventDetails.Type !== 'Rental'"
               :settings="mapSettingsWebShop"></Map>
        </div>
      </v-layout>
    </v-flex>
    <v-flex v-else-if="productFlow && !$store.getters.getMobilePhoneActive" xs12>
      <v-card class="secondSectionDetails v-card--flat">
        <div class="text-xs-center">
          <v-dialog
            v-model="genericDialog"
            persistent
            no-click-animation
            width="800">
            <v-card>
              <v-flex xs12>
                <Map v-if="genericDialog" ref="activityDetailMapBig" :settings="mapSettingsBig"></Map>
              </v-flex>
              <v-flex xs12>
                <v-layout justify-end row>
                  <v-btn @click="genericDialog = false"
                         round
                         color="primary"
                  >{{$translate('CLOSE')}}
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-card>
          </v-dialog>
        </div>
        <v-flex xs12>
          <v-btn
            color="secondary"
            round
            class="btnback btnBackForNotWebshop"
            small
            @click="goToEventHomepage()">
            {{$translate('BACK')}}
          </v-btn>
          <h1 :style="`color: ${$vuetify.theme.primary}`"
              style="font-size: 40px; margin-bottom: 1em;"
          >{{eventDetails.EventTranslationName}}</h1>
        </v-flex>
        <v-carousel hide-controls
                    :cycle="extraPictures.length === 1 ? false : true"
                    hide-delimiters
                    height="30em"
                    class="carouselBlock">
          <v-carousel-item v-for="(photo,key) in extraPictures" :key="key" :src="photo">
            <v-flex xs12>
              <v-layout layout row justify-end>
                <v-flex xs2 class="favoriteBlock">
                  <v-layout justify-center row>
                    <v-icon
                      class="favoriteIcon"
                      :color="eventDetails.Favourite ? 'red' : 'grey'"
                      x-large
                      @click="toggleFavourite(eventDetails)"
                    >favorite
                    </v-icon>
                    <p class="favoriteTextNew">
                      {{eventDetails.Favourite ? $translate('FAVORITE') : $translate('ADD_FAVORITE')}}
                    </p>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-carousel-item>
        </v-carousel>
        <v-flex xs12 style="margin-top: -2em; margin-right: 1em;">
          <v-layout row justify-end>
            <v-btn
              v-if="eventDetails.Bookable"
              :disabled="possibleDatesList.length === 0 && eventDetails.Type !== 'External'"
              @click="goToProductFlow()"
              round
              x-large
              style="margin-right: 7em; padding: 2em 10px;"
              color="primary">
              <h2 style="margin: 2em;">{{$translate('BOOK')}}
                <v-icon>arrow_forward_ios</v-icon>
              </h2>
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="mt-4">
          <v-layout row>
            <v-flex xs6>
              <p class="sizeableDescription"
                 v-html="setDescriptionText(true)"
                 :style="`border-bottom: 4px solid ${$vuetify.theme.secondary}`"
              ></p>
              <v-layout v-if="showButtons" justify-center>
                <v-btn class="descriptionButton"
                       v-if="!fullDescription"
                       round
                       color="secondary"
                       @click="setDescriptionText()">{{$translate('READ_MORE')}}
                </v-btn>
                <v-btn class="descriptionButton"
                       round
                       color="secondary"
                       v-else
                       @click="setDescriptionText()">{{$translate('READ_LESS')}}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout v-if="eventDetails.Bookable"
                        justify-center>
                <div class="ticket" @click="goToProductFlow()">
                  <p style="margin: 0 !important; font-weight: bold;"
                     :style="`color: ${$vuetify.theme.primary}`">{{$translate('STARTING_AT')}}</p>
                  <h1 style="font-size: 40px;"
                      :style="`color: ${$vuetify.theme.primary}`">{{getCheapestTicketPrice()}}</h1>
                </div>
              </v-layout>
              <v-layout
                class="ml-4"
                column
              >
                <h2
                  v-if="Object.keys(eventDetails.Suggestions).length > 0"
                  class="pa-3"
                >{{$translate('SUGGESTIONS')}}</h2>
                <v-list three-line v-if="Object.keys(eventDetails.Suggestions).length > 0">
                  <template v-for="(item, index) in eventDetails.Suggestions">
                    <v-list-tile
                      :key="index"
                      avatar
                    >
                      <v-list-tile-avatar>
                        <img v-if="item.Picture !== ''"
                             :src="item.Picture">
                        <img v-else
                             src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{setTruncatedDescription(item.Description)}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon
                          class="hoverElement"
                          @click="goToNewEvent(index)">
                          keyboard_arrow_right
                        </v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </template>
                </v-list>
                <h2
                  v-if="Object.keys(eventDetails.Alternatives).length > 0"
                  class="pa-3"
                >{{$translate('EVENT_ALTERNATIVES')}}</h2>
                <v-list three-line v-if="Object.keys(eventDetails.Alternatives).length >0">
                  <template v-for="(item, index) in eventDetails.Alternatives">
                    <v-list-tile
                      :key="index"
                      avatar
                    >
                      <v-list-tile-avatar>
                        <img v-if="item.Picture !== ''"
                             :src="item.Picture">
                        <img v-else
                             src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.EventTranslationName"></v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{setTruncatedDescription(item.Description)}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon
                          class="hoverElement"
                          @click="goToNewEvent(index)">
                          keyboard_arrow_right
                        </v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </template>
                </v-list>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="eventDetails.Bookable">
            <v-layout row>
              <v-flex xs6 style="margin-bottom: 1em;">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <p style="margin-bottom: 0 !important;">
                        <b>{{$translate('EVENT_DURATION_EC')}}:</b>
                      </p>
                    </v-flex>
                    <v-flex xs12>
                      <p>{{returnRightDurationTime()}}</p>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <p>
                    <b>{{$translate('AVA_DAYS')}}:</b>
                  </p>
                </v-flex>
                <v-flex xs12 v-if="eventDetails.hasOwnProperty('BatchGroupInfo')">
                  <v-layout column>
                    <template v-for="(item, index) in eventDetails.BatchGroupInfo.Days">
                      <v-layout row>
                        <v-flex xs6>
                          <p style="margin-bottom: 0 !important;">{{returnRightDay(item)}}</p>
                        </v-flex>
                        <p style="margin-bottom: 0 !important;">{{eventDetails.BatchGroupInfo.Times}}</p>
                      </v-layout>
                    </template>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-center align-center column>
                  <v-flex xs10
                          offset-xs1
                          class="cardForTheMapAndAddress">
                    <v-layout row>
                      <v-flex xs4 pa-3>
                        <p style="margin-bottom: 0 !important;">{{eventDetails.Location.Street}}</p>
                        <p style="margin-bottom: 0 !important;">{{eventDetails.Location.City}}</p>
                      </v-flex>
                      <v-flex xs8 @click="callingForBigMap()">
                        <Map ref="activityDetailMap" :settings="mapSettings"></Map>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <!--              <p class="clickToOpen">{{$translate('CLICK_TO_OPEN')}}</p>-->
              <v-layout row justify-space-between wrap style="margin-bottom: 5em;">
                <v-flex xs4>
                  <h1 :style="`color: ${$vuetify.theme.primary}`"
                  >{{$translate('EVENT_GRAPH_DETAILS')}}</h1>
                </v-flex>
                <v-flex xs3>
                  <v-menu
                    ref="menu3"
                    :close-on-content-click="true"
                    v-model="menu3"
                    :nudge-right="40"
                    :return-value.sync="selectedDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="computedDateFormattedSelectedDate"
                      :label="$translate('EVENT_GRAPH_DATE_PICKER')"
                      hide-details
                      append-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      first-day-of-week="1"
                      :allowed-dates="allowedPossibleDatesList"
                      :events="allowedPossibleDatesList"
                      @change="getBarChart(formatDate(selectedDate), 'myChart')"
                      color="primary"
                      v-model="selectedDate"
                      @input="$refs.menu3.save(selectedDate)"
                      no-title
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs3>
                  <v-select
                    @change="getStartDates(false)"
                    :items="Object.values(allLocations)"
                    v-model="chosenLocation"
                    item-text="LocationName"
                    return-object
                    persistent-hint
                    :label="$translate('CHOOSE_A_LOCATION')">s
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <canvas class="myChartBigScreenVersion"
                        id="myChart"></canvas>
              </v-layout>
              <h1 class="noData" v-if="noData && !noPlanBoardData">{{$translate('NO_BOOKINGS_YET')}}</h1>
            </v-flex>
            <v-flex xs12>
              <Reviews :eventDetails="eventDetails"></Reviews>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-card>
    </v-flex>
    <v-flex v-else xs12>
      <div v-if="$store.getters.getMobilePhoneActive">
        <v-card class="v-card--flat">
          <v-img
            v-if="eventDetails.PictureUrl !== 'NULL'"
            aspect-ratio="1"
            class="eventImage"
            :src="eventDetails.PictureUrl"
          >
          </v-img>
        </v-card>
        <v-layout row wrap>
          <v-flex xs12 class="bookingContainerMobileVersion">
            <v-layout column wrap>
              <v-flex xs12>
                <v-card class="toggleContent v-card--flat">
                  <v-flex xs12 v-if="stepperSteps == 1">
                    <v-layout row wrap>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">
                        <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                                style="width: 2.5em !important;">
                          <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">1/3</p>
                        </v-chip>
                        {{$translate('RENTAL_PERIOD')}}
                      </h2>
                      <v-flex xs12 class="searchBarFlex">
                        <p>{{$translate('SELECTED_DATA_EXPLANATION')}}</p>
                        <v-layout align-center justify-center mt-2>
                          <v-card class="rounded-card rentalInputDates v-card--flat">
                            <v-layout row wrap>
                              <v-card style="width: 100%;" class="sizeForSearchBlock v-card--flat">
                                <v-flex xs12>
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        ref="menu1"
                                        :close-on-content-click="true"
                                        v-model="menu1"
                                        :nudge-right="40"
                                        :return-value.sync="chosenStartDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                        :disabled="allowedStartDate.length === 1"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedStartDate.length === 1"
                                          v-model="computedDateFormattedStartDate"
                                          :label="allowedStartDate.length === 1 ? $translate('STARTDATE') :$translate('PLEASE_STARTDATE')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :allowed-dates="allowedStartDates"
                                          :events="allowedStartDates"
                                          first-day-of-week="1"
                                          @change="callingSecondFunctionForRentalBar(1)"
                                          color="primary"
                                          v-model="chosenStartDate"
                                          @input="$refs.menu1.save(chosenStartDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="callingSecondFunctionForRentalBar(2)"
                                                :disabled="Object.values(rentalStartTimes).length === 1"
                                                :items="Object.values(rentalStartTimes)"
                                                v-model="rentalStartTime"
                                                return-object
                                                persistent-hint
                                                :label="Object.values(rentalStartTimes).length === 1  ? $translate('CALENDAR_EVENT_STARTTIME'): $translate('PLEASE_STARTTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>{{data.item.StartTime + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus', data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em; transform: scale(0.8);">
                                                    {{$translate(getChipData('text', data.item))}}
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        :disabled="allowedEndDate.length === 1"
                                        ref="menu2"
                                        :close-on-content-click="true"
                                        v-model="menu2"
                                        :nudge-right="40"
                                        :return-value.sync="chosenEndDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedEndDate.length === 1"
                                          v-model="computedDateFormattedEndDate"
                                          :label="allowedEndDate.length === 1 ? $translate('ENDDATE') : $translate('PLEASE_ENDDATE')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :disabled="allowedEndDate.length === 1"
                                          :events="allowedEndDates"
                                          :allowed-dates="allowedEndDates"
                                          first-day-of-week="1"
                                          color="primary"
                                          v-model="chosenEndDate"
                                          @change="callingSecondFunctionForRentalBar(3)"
                                          @input="$refs.menu2.save(chosenEndDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="checkForBookButton()"
                                                :disabled="Object.values(rentalEndTimes).length === 1"
                                                :items="Object.values(rentalEndTimes)"
                                                v-model="rentalEndTime"
                                                return-object
                                                persistent-hint
                                                :label="rentalEndTime !== '' ? $translate('CALENDAR_EVENT_ENDTIME') : $translate('PLEASE_ENDTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>{{data.item.StartTime + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus', data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em; transform: scale(0.8);">
                                                    {{$translate(getChipData('text', data.item))}}
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-card>
                            </v-layout>
                          </v-card>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout column>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">
                        <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                                style="width: 2.5em !important;">
                          <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">2/3</p>
                        </v-chip>
                        {{$translate('CHOOSE_AN_OPTION')}}
                      </h2>
                      <p>{{$translate('SHOWING_OPTION')}}</p>
                      <v-list two-line>
                        <template v-for="(item, index) in tickets">
                          <v-card class="optionsCard v-card--flat">
                            <v-list-tile
                              :key="index"
                              avatar
                              ripple
                            >
                              <v-list-tile-content class="listContent">
                                <h3>{{item.Name}}</h3>
                                <p style="max-width: 45em; max-height: 3em; overflow: auto;">{{ item.Description }}</p>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-layout row>
                                  <h3 style="margin: 0 0.5em;">€{{ roundPrice(item.Price) }}</h3>
                                  <v-btn style="margin: 0 0.5em;"
                                         @click="item.Amount === item.MinAmount ? item.Amount = item.MinAmount : item.Amount--; checkTickets(item)"
                                         fab dark class="plusOrMinusButton" small color="primary">
                                    <v-icon dark>remove</v-icon>
                                  </v-btn>
                                  <h3 class="ticketAmount">{{item.Amount > 0 ? item.Amount : 0}}</h3>
                                  <v-btn style="margin: 0 0.5em;"
                                         @click="item.ForAge > 17 ? acceptAge(item) : checkTickets(item, true)"
                                         class="plusOrMinusButton" fab dark small color="primary">
                                    <v-icon dark>add</v-icon>
                                  </v-btn>
                                </v-layout>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-card>
                        </template>
                      </v-list>
                    </v-layout>
                    <h2 :style="`color: ${$vuetify.theme.primary}`">
                      <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                              style="width: 2.5em !important;">
                        <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">3/3</p>
                      </v-chip>
                      {{$translate('ENTER_YOUR_PERSONAL_DETAILS')}}
                    </h2>
                    <p>{{$translate('PERSONAL_DETAILS_EXPLANATION')}}</p>
                    <v-layout row wrap justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('FIRSTNAME')"
                          v-model="userInputs[11]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('LASTNAME')"
                          v-model="userInputs[12]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          class="inputPhone"
                          @input="checkForBookButton()"
                          :label="$translate('PHONE_NR_REQUIRED')"
                          v-model="userInputs[19]"
                          append-icon="phone"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-flex xs5>
                      <v-textarea
                        :label="$translate('REMARK_OPTIONAL')"
                        auto-grow
                        no-resize
                        rows="1"
                        v-model="remark"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="checkbox"
                        :label="$translate('SAVE_DETAILS')"
                      ></v-checkbox>
                    </v-flex>
                    <v-layout justify-center row>
                      <hr style="display: none; margin-bottom: 5em;">
                    </v-layout>
                    <v-flex xs12>
                      <v-layout justify-space-between>
                        <v-btn
                          round
                          medium
                          color="secondary"
                          @click="goBackToDetailsFlow()"
                        >
                          {{$translate('BACK')}}
                        </v-btn>
                        <v-btn
                          v-if="!priceCategoriesOrProducts"
                          :disabled="bookButton || loading"
                          round
                          medium
                          color="primary"
                          @click="bookBatch()"
                        >
                          {{$translate('CONTINUE')}}
                        </v-btn>
                      </v-layout>
                      <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="primary"
                        class="loadingBar"
                      ></v-progress-linear>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 v-if="stepperSteps == 2">
                    <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('CONFIRM_YOUR_CHOICES')}}</h1>
                    <p style="font-size: 18px">{{$translate('CONFIRM_YOUR_CHOICES_EXPLANATION')}}</p>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-list style="padding-top: 0;" two-line>
                          <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('YOUR_ORDER')}}:</h2>
                          <template v-for="(item, index) in userOrder.Order">
                            <v-list-tile
                              v-if="item.OrderItemType != 'DeliveryCost'"
                              class="orderListItem"
                              :key="item.Id"
                              avatar
                            >
                              <v-list-tile-avatar size="100" class="orderListAvatar" tile>
                                <v-img contain :aspect-ratio="16/9" :src="item.ProductPicture"/>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>{{item.ProductName == '' ? item.PriceCategoryName :
                                  item.ProductName}} {{item.Aspects}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="color: black;">
                                  <v-layout row justify-end><b>{{item.hasOwnProperty('GroupSize') ? item.GroupSize :
                                    item.Quantity}}x €{{eventDetails.Type == 'Fixed' || eventDetails.Type ==
                                    'Repetitive' ? roundPrice(item.PriceCategoryPrice) :
                                    roundPrice(item.ItemPrice)}}</b></v-layout>
                                </v-list-tile-sub-title>

                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider class="dividerStyle"></v-divider>
                          </template>
                          <v-layout align-end justify-start column fill-height>
                            <h3 style="padding-right: 1em;"
                                v-if="totalPrice !== userOrder.OrderTotalPrice && DeliveryOrTakeaway == 'Delivery'">
                              {{$translate('EX_DELIVERY_FEE')}} : €{{roundPrice(userOrder.OrderTotalPrice -
                              DeliveryDistance.Price)}}</h3>
                            <h3 class="freeDelivery"
                                v-else-if="totalPrice == userOrder.OrderTotalPrice && DeliveryOrTakeaway == 'Delivery'">
                              {{$translate('FREE_DELIVERY')}} </h3>
                            <h2 style="padding-right: 0.7em;">{{$translate('TOTAL')}}:
                              €{{userOrder.OrderTotalPrice}}</h2>
                          </v-layout>
                        </v-list>
                      </v-flex>
                      <v-flex xs12>
                        <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('USER_SELECTIONS')}}:</h2>
                        <p v-if="chosenStartDate !== ''"
                           class="adressStyling">
                          <b>{{$translate('STARTDATE')}}</b>: {{chosenStartDate.split('-').reverse().join('-')}}</p>
                        <p v-if="chosenEndDate !== ''"
                           class="adressStyling">
                          <b>{{$translate('ENDDATE')}}</b>: {{chosenEndDate.split('-').reverse().join('-')}}</p>
                        <p v-if="rentalStartTime.hasOwnProperty('StartTime')"
                           class="adressStyling">
                          <b>{{$translate('LINDA_STARTTIME')}}</b>:
                          {{rentalStartTime.StartTime}} - {{rentalStartTime.EndTime}}</p>
                        <p v-if="rentalEndTime !== undefined && rentalEndTime.hasOwnProperty('StartTime')"
                           class="adressStyling">
                          <b>{{$translate('LINDA_ENDTIME')}}</b>:
                          {{rentalEndTime.StartTime}} - {{rentalEndTime.EndTime}}</p>
                        <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('USER_DETAILS')}}:</h2>
                        <p v-if="userDetails.hasOwnProperty('PhoneNumber')" class="adressStyling"><b>{{$translate('PHONE_NR')}}</b>:
                          {{userDetails.PhoneNumber}}</p>
                        <p v-if="this.remark != ''" class="adressStyling"><b>{{$translate('REMARK')}}</b>:
                          {{this.remark}}</p>
                      </v-flex>
                      <div class="text-xs-center">
                        <v-dialog
                          v-model="notAllAvaiblable"
                          width="500"
                        >
                          <v-card>
                            <v-card-title
                              class="headline grey lighten-2"
                              primary-title
                            >
                              {{$translate('UNAVAILABLE')}}
                            </v-card-title>
                            <v-card-text>
                              {{$translate('UNAVAILABLE_TEXT')}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                round
                                color="secondary"
                                @click="notAllAvaiblable = false"
                              >
                                {{$translate('CANCEL')}}
                              </v-btn>
                              <v-btn
                                round
                                color="primary"
                                @click="confirmOrderLoading()"
                              >
                                {{$translate('ACCEPT')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                      <v-flex xs12>
                        <v-layout justify-space-between>
                          <v-btn
                            round
                            medium
                            color="secondary"
                            @click="cancelOrder()"
                          >
                            {{$translate('BACK')}}
                          </v-btn>
                          <v-btn
                            round
                            medium
                            color="primary"
                            @click="checkProductStatesBeforeConfirm()"
                          >
                            {{$translate('CONFIRM')}}
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>

            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <v-flex xs12 style="width: 1000px; margin: auto; padding-top: 4em;">
          <v-flex xs12>
            <h1 :style="`color: ${$vuetify.theme.primary}`"
                style="font-size: 40px; margin-bottom: 1em;"
            >{{eventDetails.EventTranslationName}}</h1>
          </v-flex>
          <v-carousel hide-controls
                      hide-delimiters
                      :cycle="extraPictures.length === 1 ? false : true"
                      height="30em"
                      class="carouselBlock">
            <v-carousel-item v-for="(photo,key) in extraPictures" :key="key" :src="photo">
              <v-flex xs12>
                <v-layout layout row justify-end>
                  <v-flex xs2 class="favoriteBlock">
                    <v-layout justify-center row>
                      <v-icon
                        class="favoriteIcon"
                        :color="eventDetails.Favourite ? 'red' : 'grey'"
                        x-large
                        @click="toggleFavourite(eventDetails)"
                      >favorite
                      </v-icon>
                      <p class="favoriteTextNew">
                        {{eventDetails.Favourite ? $translate('FAVORITE') : $translate('ADD_FAVORITE')}}
                      </p>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-carousel-item>
          </v-carousel>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs12 class="bookingContainer">
            <v-layout column wrap>
              <v-flex xs12>
                <v-card class="toggleContent v-card--flat">
                  <v-flex xs12 v-if="stepperSteps == 1">
                    <v-layout row wrap>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">
                        <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                                style="width: 2.5em !important;">
                          <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">1/3</p>
                        </v-chip>
                        {{$translate('RENTAL_PERIOD')}}
                      </h2>
                      <v-flex xs12 class="searchBarFlex">
                        <p>{{$translate('SELECTED_DATA_EXPLANATION')}}</p>
                        <v-layout align-center justify-center mt-2>
                          <v-card class="rounded-card rentalInputDates v-card--flat">
                            <v-layout row wrap>
                              <v-card style="width: 100%;" class="sizeForSearchBlock v-card--flat">
                                <v-flex xs5>
                                  <v-select
                                    @change="getStartDates(true)"
                                    :items="Object.values(allLocations)"
                                    v-model="chosenLocation"
                                    item-text="LocationName"
                                    return-object
                                    persistent-hint
                                    :label="$translate('CHOOSE_A_LOCATION')">
                                  </v-select>
                                </v-flex>
                                <v-flex xs12>
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        ref="menu1"
                                        :close-on-content-click="true"
                                        v-model="menu1"
                                        :nudge-right="40"
                                        :return-value.sync="chosenStartDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                        :disabled="allowedStartDate.length === 1"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedStartDate.length === 1"
                                          v-model="computedDateFormattedStartDate"
                                          :label="allowedStartDate.length === 1 ? $translate('STARTDATE') :$translate('PLEASE_STARTDATE')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :allowed-dates="allowedStartDates"
                                          :events="allowedStartDates"
                                          first-day-of-week="1"
                                          @change="callingSecondFunctionForRentalBar(1)"
                                          color="primary"
                                          v-model="chosenStartDate"
                                          @input="$refs.menu1.save(chosenStartDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="callingSecondFunctionForRentalBar(2)"
                                                :disabled="Object.values(rentalStartTimes).length === 1"
                                                :items="Object.values(rentalStartTimes)"
                                                v-model="rentalStartTime"
                                                return-object
                                                persistent-hint
                                                :label="Object.values(rentalStartTimes).length === 1 ? $translate('CALENDAR_EVENT_STARTTIME'): $translate('PLEASE_STARTTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>{{data.item.StartTime + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus', data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em; transform: scale(0.8);">
                                                    {{$translate(getChipData('text', data.item))}}
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                  <v-layout row justify-space-between>
                                    <v-flex xs5>
                                      <v-menu
                                        :disabled="allowedEndDate.length === 1"
                                        ref="menu2"
                                        :close-on-content-click="true"
                                        v-model="menu2"
                                        :nudge-right="40"
                                        :return-value.sync="chosenEndDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <v-text-field
                                          slot="activator"
                                          :disabled="allowedEndDate.length === 1"
                                          v-model="computedDateFormattedEndDate"
                                          :label="allowedEndDate.length === 1 ? $translate('ENDDATE') : $translate('PLEASE_ENDDATE')"
                                          hide-details
                                          append-icon="event"
                                          readonly
                                          ref="eventForm"
                                        ></v-text-field>
                                        <v-date-picker
                                          :disabled="allowedEndDate.length === 1"
                                          :events="allowedEndDates"
                                          :allowed-dates="allowedEndDates"
                                          first-day-of-week="1"
                                          color="primary"
                                          v-model="chosenEndDate"
                                          @change="callingSecondFunctionForRentalBar(3)"
                                          @input="$refs.menu2.save(chosenEndDate)"
                                          no-title
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs5>
                                      <v-select append-icon="access_time"
                                                @change="checkForBookButton()"
                                                :disabled="Object.values(rentalEndTimes).length === 1"
                                                :items="Object.values(rentalEndTimes)"
                                                v-model="rentalEndTime"
                                                return-object
                                                persistent-hint
                                                :label="rentalEndTime !== '' ? $translate('CALENDAR_EVENT_ENDTIME') : $translate('PLEASE_ENDTIME')">
                                        <template slot="selection" slot-scope="data">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ data.item.StartTime }} - {{ data.item.EndTime }}
                                        </template>
                                        <template
                                          slot="item"
                                          slot-scope="data"
                                        >
                                          <template>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-space-between
                                                        style="width: 100% !important;">
                                                <v-list-tile-title>{{data.item.StartTime + ' - ' + data.item.EndTime}}
                                                </v-list-tile-title>
                                                <div class="text-xs-center">
                                                  <v-chip :dark="getChipData('darkModus', data.item)"
                                                          :style="`background-color: ${getChipData('color', data.item)}`"
                                                          style="padding: 0.1em; transform: scale(0.8);">
                                                    {{$translate(getChipData('text', data.item))}}
                                                  </v-chip>
                                                </div>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </template>
                                        </template>
                                      </v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-card>
                            </v-layout>
                          </v-card>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout column>
                      <h2 :style="`color: ${$vuetify.theme.primary}`">
                        <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                                style="width: 2.5em !important;">
                          <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">2/3</p>
                        </v-chip>
                        {{$translate('CHOOSE_AN_OPTION')}}
                      </h2>
                      <p>{{$translate('SHOWING_OPTION')}}</p>
                      <v-list two-line>
                        <template v-for="(item, index) in tickets">
                          <v-card class="optionsCard">
                            <v-list-tile
                              :key="index"
                              avatar
                              ripple
                            >
                              <v-list-tile-content class="listContent">
                                <h3>{{item.Name}}</h3>
                                <p style="max-width: 45em; max-height: 3em; overflow: auto;">{{ item.Description }}</p>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-layout row>
                                  <h3 style="margin: 0 0.5em;">€{{ roundPrice(item.Price) }}</h3>
                                  <v-btn style="margin: 0 0.5em;"
                                         @click="item.Amount === item.MinAmount ? item.Amount = item.MinAmount : item.Amount--; checkTickets(item)"
                                         fab dark class="plusOrMinusButton" small color="primary">
                                    <v-icon dark>remove</v-icon>
                                  </v-btn>
                                  <h3 class="ticketAmount">{{item.Amount > 0 ? item.Amount : 0}}</h3>
                                  <v-btn style="margin: 0 0.5em;"
                                         @click="item.ForAge > 17 ? acceptAge(item) : checkTickets(item, true)"
                                         class="plusOrMinusButton" fab dark small color="primary">
                                    <v-icon dark>add</v-icon>
                                  </v-btn>
                                </v-layout>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-card>
                        </template>
                      </v-list>
                    </v-layout>
                    <h2 :style="`color: ${$vuetify.theme.primary}`">
                      <v-chip :style="`background-color: ${$vuetify.theme.primary}`"
                              style="width: 2.5em !important;">
                        <p style="color: white; margin: 0 !important; margin-left: -0.4em !important;">3/3</p>
                      </v-chip>
                      {{$translate('ENTER_YOUR_PERSONAL_DETAILS')}}
                    </h2>
                    <p>{{$translate('PERSONAL_DETAILS_EXPLANATION')}}</p>
                    <v-layout row wrap justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('FIRSTNAME')"
                          v-model="userInputs[11]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          @input="checkForBookButton()"
                          :label="$translate('LASTNAME')"
                          v-model="userInputs[12]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          class="inputPhone"
                          @input="checkForBookButton()"
                          :label="$translate('PHONE_NR_REQUIRED')"
                          v-model="userInputs[19]"
                          append-icon="phone"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-flex xs5>
                      <v-textarea
                        :label="$translate('REMARK_OPTIONAL')"
                        auto-grow
                        no-resize
                        rows="1"
                        v-model="remark"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="checkbox"
                        :label="$translate('SAVE_DETAILS')"
                      ></v-checkbox>
                    </v-flex>
                    <v-layout justify-center row>
                      <hr style="display: none; margin-bottom: 5em;">
                    </v-layout>
                    <v-flex xs12>
                      <v-layout justify-space-between>
                        <v-btn
                          round
                          medium
                          color="secondary"
                          @click="goBackToDetailsFlow()"
                        >
                          {{$translate('BACK')}}
                        </v-btn>
                        <v-btn
                          v-if="!priceCategoriesOrProducts"
                          :disabled="bookButton || loading"
                          round
                          medium
                          color="primary"
                          @click="bookBatch()"
                        >
                          {{$translate('CONTINUE')}}
                        </v-btn>
                      </v-layout>
                      <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="primary"
                        class="loadingBar"
                      ></v-progress-linear>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 v-if="stepperSteps == 2">
                    <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('CONFIRM_YOUR_CHOICES')}}</h1>
                    <p style="font-size: 18px">{{$translate('CONFIRM_YOUR_CHOICES_EXPLANATION')}}</p>
                    <v-layout row justify-space-between wrap>
                      <v-flex xs12>
                        <v-list style="padding-top: 0;" two-line>
                          <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('YOUR_ORDER')}}:</h2>
                          <template v-for="(item, index) in userOrder.Order">
                            <v-list-tile
                              v-if="item.OrderItemType !== 'DeliveryCost'"
                              class="orderListItem"
                              :key="item.Id"
                              avatar
                            >
                              <v-list-tile-avatar v-if="item.ProductPicture !== undefined && item.ProductPicture !== ''"
                                                  size="100" class="orderListAvatar" tile>
                                <v-img contain :aspect-ratio="16/9" :src="item.ProductPicture"/>
                              </v-list-tile-avatar>

                              <v-list-tile-content style="overflow: unset;">
                                <v-card class="v-card--flat" style="width: 100%;">
                                  <v-layout row>
                                    <v-flex x8>
                                      <v-list-tile-title><b>{{item.ProductName == '' ? item.PriceCategoryName :
                                        item.ProductName}} {{item.Aspects}}</b></v-list-tile-title>
                                      <v-list-tile-sub-title>{{item.PriceCategoryDescription}}</v-list-tile-sub-title>
                                      <v-list-tile-sub-title>€{{eventDetails.Type == 'FlexEvent' ?
                                        roundPrice(item.ItemPrice) : roundPrice(item.PriceCategoryPrice)}}
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>{{$translate('QUANTITY')}}: <b>{{item.Quantity}}</b>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-list-tile-sub-title style="color: black;">
                                        <v-layout row justify-end><b>{{$translate('SUBTOTAL')}}:
                                          €{{roundPrice(item.Quantity * item.PriceCategoryPrice)}}</b></v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-card>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider class="dividerStyle"></v-divider>
                          </template>
                          <v-layout align-end justify-start column fill-height>
                            <h2 style="padding-right: 0.7em;">{{$translate('TOTAL')}}:
                              €{{userOrder.OrderTotalPrice}}</h2>
                          </v-layout>
                        </v-list>
                        <v-divider class="dividerStyle"></v-divider>
                      </v-flex>
                      <v-flex xs5>
                        <h2 :style="`color: ${$vuetify.theme.primary}`"
                            style="margin-bottom: 1em;"
                        >{{$translate('USER_SELECTIONS')}}:</h2>
                        <v-layout row>
                          <v-flex xs4>
                            <p v-if="chosenStartDate !== ''"
                               class="adressStyling">
                              <b>{{$translate('STARTDATE')}}</b>:</p>
                            <p v-if="chosenEndDate !== ''"
                               class="adressStyling">
                              <b>{{$translate('ENDDATE')}}</b>:</p>
                            <p v-if="rentalStartTime.hasOwnProperty('StartTime')"
                               class="adressStyling">
                              <b>{{$translate('LINDA_STARTTIME')}}</b>:</p>
                            <p v-if="rentalEndTime !== undefined && rentalEndTime.hasOwnProperty('StartTime')"
                               class="adressStyling">
                              <b>{{$translate('LINDA_ENDTIME')}}</b>:</p>
                          </v-flex>
                          <v-flex xs6>
                            <p v-if="chosenStartDate !== ''"
                               class="adressStyling">{{chosenStartDate.split('-').reverse().join('-')}}</p>
                            <p v-if="chosenEndDate !== ''"
                               class="adressStyling">{{chosenEndDate.split('-').reverse().join('-')}}</p>
                            <p v-if="rentalStartTime.hasOwnProperty('StartTime')"
                               class="adressStyling">{{rentalStartTime.StartTime}} - {{rentalStartTime.EndTime}}</p>
                            <p v-if="rentalEndTime !== undefined && rentalEndTime.hasOwnProperty('StartTime')"
                               class="adressStyling">{{rentalEndTime.StartTime}} - {{rentalEndTime.EndTime}}</p>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs5>
                        <h2 :style="`color: ${$vuetify.theme.primary}`"
                            style="margin-bottom: 1em;"
                        >{{$translate('USER_DETAILS')}}:</h2>
                        <v-layout row>
                          <v-flex xs4>
                            <p v-if="userDetails.hasOwnProperty('Name')" class="adressStyling">
                              <b>{{$translate('NAME')}}</b>:</p>
                            <p v-if="userDetails.hasOwnProperty('PhoneNumber')" class="adressStyling"><b>{{$translate('PHONE_NR')}}</b>:
                            </p>
                            <p v-if="this.remark !== ''" class="adressStyling"><b>{{$translate('REMARK')}}</b>:</p>
                          </v-flex>
                          <v-flex xs6>
                            <p v-if="userDetails.hasOwnProperty('Name')" class="adressStyling">{{userDetails.Name}}</p>
                            <p v-if="userDetails.hasOwnProperty('PhoneNumber')" class="adressStyling">
                              {{userDetails.PhoneNumber}}</p>
                            <p v-if="this.remark !== ''" class="adressStyling">{{this.remark}}</p>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <div class="text-xs-center">
                        <v-dialog
                          v-model="notAllAvaiblable"
                          width="500"
                        >
                          <v-card>
                            <v-card-title
                              class="headline grey lighten-2"
                              primary-title
                            >
                              {{$translate('UNAVAILABLE')}}
                            </v-card-title>
                            <v-card-text>
                              {{$translate('UNAVAILABLE_TEXT')}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                round
                                color="secondary"
                                @click="notAllAvaiblable = false"
                              >
                                {{$translate('CANCEL')}}
                              </v-btn>
                              <v-btn
                                round
                                color="primary"
                                @click="confirmOrderLoading()"
                              >
                                {{$translate('ACCEPT')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                      <v-flex xs12 style="margin-top: 2em;">
                        <v-layout justify-space-between>
                          <v-btn
                            round
                            medium
                            color="secondary"
                            @click="cancelOrder()"
                          >
                            {{$translate('BACK')}}
                          </v-btn>
                          <v-btn
                            round
                            medium
                            color="primary"
                            @click="checkProductStatesBeforeConfirm()"
                          >
                            {{$translate('CONFIRM')}}
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-card>
</template>
<script>
  import MapOverview from '@/components/Map_Overview';
  import _ from 'lodash';
  import { mapGetters } from 'vuex';
  import Chart from 'chart.js';
  import BookObject from '@/objects/BookObject';
  import * as dssRequest from '../api/dssRequest';
  import appConfig from '../../config/app_config';
  import { store } from '../store';
  import BatchObject from '../objects/BatchObject';
  import 'chartjs-plugin-zoom';
  import Map from '../Maps/Map';
  import MapObject from '../Maps/MapObject';
  import Reviews from '@/components/Reviews';

  export default {
    components: {
      MapOverview,
      Map,
      Reviews,
    },
    data() {
      return {
        // locations
        chosenLocation: '',
        allLocations: {},
        // categories
        arrayWithCategories: [],
        // extra variables
        genericDialog: false,
        loading: false,
        possibleDatesList: [],
        selectedDate: '',
        // description
        fullDescription: false,
        showButtons: true,
        // categories
        chosenCategorie: '',
        allCategories: [],
        page: 0,
        // chart
        noPlanBoardData: false,
        chartData: {},
        noData: false,
        // rental
        foundProductInSearch: {},
        batchGroupList: [],
        rentalEndTimes: [],
        rentalStartTimes: [],
        rentalEndTime: '',
        rentalStartTime: '',
        allowedEndDate: [],
        allowedStartDate: [],
        chosenStartDate: '',
        chosenEndDate: '',
        menu1: '',
        menu2: '',
        menu3: '',
        // Batch
        bookButton: true,
        batchErrorMSG: '',
        // Delivery
        DeliveryOrTakeawayDisabled: false,

        sheet: false,
        activeBtn: 1,
        showNav: true,
        // NewScreen
        forAgeAbove17Product: {},
        forAgeAbove17: false,
        noBatch: true,
        switchContent: false,
        selectedOrderType: '',
        // shopping cart
        DeliveryOrTakeawayItems: [],
        DeliveryOrTakeaway: '',
        totalPrice: 0,
        shoppingCartTotal: 0,
        shoppingCart: [],
        // products
        tickets: {},
        productFlow: true,
        Amount: 0,
        finalProduct: {
          Amount: 1,
        },
        priceCategoriesOrProducts: undefined,
        chosenProduct: {},
        products: {},
        // map
        activityLocation: {},
        activityDetailMapWebShop: {},
        activityDetailMapBig: {},
        activityDetailMap: {},
        showMap: true,
        currentDaysToSend: 0,
        extraPictures: [],
        eventDetails: {},
        mapSettingsWebShop: {
          name: 'activityDetailMapWebShop',
          view: {
            zoom: 9,
          },
          interactions: {
            doubleClickZoom: true,
            dragAndDrop: true,
            dragPan: true,
            keyboardPan: true,
            keyboardZoom: true,
            mouseWheelZoom: true,
            pointer: true,
            select: true,
          },
          controls: {
            zoomControls: true,
            filterOption: false,
          },
          style: 'width: 100%; height: calc(60vh);',
        },
        mapSettingsBig: {
          name: 'activityDetailMapBig',
          view: {
            zoom: 9,
          },
          interactions: {
            doubleClickZoom: true,
            dragAndDrop: true,
            dragPan: true,
            keyboardPan: true,
            keyboardZoom: true,
            mouseWheelZoom: true,
            pointer: true,
            select: true,
          },
          controls: {
            zoomControls: true,
            filterOption: false,
          },
          style: 'width: 800px; height: calc(60vh);',
        },
        mapSettings: {
          name: 'activityDetailMap',
          view: {
            zoom: 18,
          },
          interactions: {
            doubleClickZoom: false,
            dragAndDrop: false,
            dragPan: false,
            keyboardPan: false,
            keyboardZoom: false,
            mouseWheelZoom: false,
            pointer: true,
            select: true,
          },
          controls: {
            zoomControls: false,
            filterOption: false,
          },
          style: 'width: 100%; height: 100%;',
        },
        howBackButton: false,
        // Order
        notAllAvaiblable: false,
        stepperSteps: 1,
        userOrder: {},
        // calendar
        calendarList: [],
        // UserData
        userDetails: {},
        DeliveryDistance: {},
        deliveryArray: [],
        checkbox: false,
        locationNotFound: false,
        remark: '',
        saveUserData: false,
        userInputs: {},
      };
    },
    computed: {
      ...mapGetters({
        _userLanguage: 'getUserLanguage',
      }),
      computedDateFormattedStartDate() {
        return this.formatDate(this.chosenStartDate);
      },
      computedDateFormattedEndDate() {
        return this.formatDate(this.chosenEndDate);
      },
      computedDateFormattedSelectedDate() {
        return this.formatDate(this.selectedDate);
      },
      pricePrefix() {
        return this.eventDetails.Type === 'Rental' ? 'Price starts at: €' : '€';
      },
    },
    watch: {
      _userLanguage(newV, oldV) {
        if (Number(newV) !== Number(oldV)) {
          this.getEventDetails(true);
        }
      },
    },
    created() {
      window.EventBus.listen(
        'fireNewUserLanguage',
        this.getEventDetails,
      );
    },
    beforeDestroy() {
      window.EventBus.removeListener(
        'fireNewUserLanguage',
        this.getEventDetails,
      );
      this.$store.commit('setADS', false);
      this.$store.commit('setSelectedEventId', '');
    },
    mounted() {
      this.selectedDate = new Date().toISOString()
        .slice(0, 10);
      this.$store.commit('setADS', true);
      this.$store.commit('setUserGoesBackToHomepage', false);
      if (!_.isEmpty(this.$store.getters.getShoppingCart)) {
        if (this.$store.getters['auth/userName'] !== '') {
          this.totalPrice = this.$store.getters.getShoppingCart.TotalPrice;
          delete this.$store.getters.getShoppingCart.TotalPrice;
          this.shoppingCart = this.$store.getters.getShoppingCart;
          this.$store.commit('setShoppingCart', {});
          this.productFlow = false;
        } else {
          this.totalPrice = this.$store.getters.getShoppingCart.TotalPrice;
          delete this.$store.getters.getShoppingCart.TotalPrice;
          this.shoppingCart = this.$store.getters.getShoppingCart;
          this.$store.commit('setShoppingCart', {});
          this.productFlow = true;
          if (this.DeliveryOrTakeawayItems.length !== 0) {
            this.getStartDates(true);
          }
          ;
        }
      }
      this.getEventDetails();
      window.scrollTo({
        top: 0,
        left: 0,
      });
    },
    methods: {
      getCheapestTicketPrice() {
        let cheapest = 0;
        if (this.eventDetails.PriceCategories === undefined) return;
        for (const [index, item] of Object.entries(this.eventDetails.PriceCategories)) {
          if (cheapest === 0
            || Number(item.Price) < cheapest
            && Number(item.Price)
              .toFixed(2) !== 0.00) {
            cheapest = Number(item.Price);
          }
        }
        return `€${cheapest.toFixed(2)}`;
      },
      scrollToSendingPostion(sendingTop, sendingLeft) {
        window.scrollTo({
          top: sendingTop,
          left: sendingLeft,
        });
      },
      setTruncatedDescription(description) {
        let truncated = description;
        console.log('Lorenzo truncated', truncated);
        const maxDescriptionLength = 120;
        if (truncated.length > maxDescriptionLength) {
          truncated = `${truncated.substr(0, maxDescriptionLength)}...`;
        }
        return truncated;
      },
      setDescriptionText(value) {
        if (!this.eventDetails.hasOwnProperty('Type')) return;
        console.log('Lorenzo kom ik hier langs zo jah why', this.eventDetails);
        const sizeOfScreen = window.innerHeight;
        if (value !== true) this.fullDescription = !this.fullDescription;
        let truncated = this.eventDetails.Description;
        console.log('Lorenzo truncated', truncated);
        truncated = truncated.replace(/\n/g, '<br>');
        if (this.fullDescription) return truncated;

        if (this.eventDetails.hasOwnProperty('Description')) {
          const maxDescriptionLength = 300;
          if (truncated.length > maxDescriptionLength) {
            truncated = `${truncated.substr(0, maxDescriptionLength)}...`;
          } else {
            this.showButtons = false;
          }
          return truncated;
        }
      },
      goBackToDetailsFlow() {

        this.productFlow = true;
        if (this.DeliveryOrTakeawayItems.length != 0) {
          this.getStartDates(true);
        }
        ;
        if (this.eventDetails.Type !== 'Rental') {
          this.shoppingCart = [];
          this.getBarChart(this.formatDate(this.selectedDate), 'myChart');
          setTimeout(() => {
            this.initializeActivityDetailMap(this.activityLocation);
          }, 1000);
        }
        this.remark = '';
        this.checkbox = false;
        this.userInputs[11] = '';
        this.userInputs[12] = '';
        this.userInputs[14] = '';
        this.userInputs[15] = '';
        this.userInputs[17] = '';
        this.userInputs[19] = '';
      },
      checkForBookButton() {
        // checks inputfields for orderEvent
        if (this.eventDetails.Type === 'OrderEvent') {
          if (this.DeliveryOrTakeaway === 'Delivery') {
            if (this.chosenStartDate !== ''
              && !_.isEmpty(this.rentalStartTime)
              && this.shoppingCart.length !== 0
              && this.userInputs[11] !== ''
              && this.userInputs[12] !== ''
              && this.userInputs[14] !== ''
              && this.userInputs[15] !== ''
              && this.userInputs[17] !== ''
              && this.userInputs[19] !== ''
              && this.userInputs[19] !== undefined
              && !_.isEmpty(this.DeliveryDistance)) {
              this.bookButton = false;
            } else {
              this.bookButton = true;
            }
          } else if (this.eventDetails.Type === 'Rental') {
            if (this.chosenStartDate !== ''
              && this.chosenEndDate !== ''
              && !_.isEmpty(this.rentalStartTime)
              && !_.isEmpty(this.rentalEndTime)
              && this.shoppingCart.length !== 0
              && this.userInputs[11] !== ''
              && this.userInputs[12] !== ''
              && this.userInputs[19] !== ''
              && this.userInputs[19] !== undefined) {
              this.bookButton = false;
            } else {
              this.bookButton = true;
            }
          } else if (this.chosenStartDate !== ''
            && !_.isEmpty(this.rentalStartTime)
            && this.shoppingCart.length !== 0
            && this.userInputs[11] !== ''
            && this.userInputs[12] !== ''
            && this.userInputs[19] !== ''
            && this.userInputs[19] !== undefined) {
            this.bookButton = false;
          } else {
            this.bookButton = true;
          }
        }
        // checks inputfields for repetitive, tour, fixed & flex
        else if (this.chosenStartDate !== ''
          && this.userInputs[11] !== ''
          && this.userInputs[12] !== ''
          && this.chosenEndDate !== ''
          && !_.isEmpty(this.rentalStartTime)
          && !_.isEmpty(this.rentalEndTime)
          && this.shoppingCart.length !== 0
          && this.userInputs[19] !== ''
          && this.userInputs[19] !== undefined) {
          this.bookButton = false;
        } else {
          this.bookButton = true;
        }
      },
      goToProductFlow() {
        if (this.$store.getters['auth/userName'] == '') {
          this.$store.commit('setGoToAfterLoginOrRegister', `event:${this.$store.getters.getChosenEvent}`);
          this.goToLogin();
        } else {

          if (this.allLocations != null && this.allLocations.length > 0) {
            this.chosenLocation = this.allLocations[0];
          } else {
            console.log('Brian this.chosenLocation', this.chosenLocation);

            // Use default location to get start dates
            this.chosenLocation.LocationId = this.eventDetails.LocationId;
            this.chosenLocation.LocationName = this.eventDetails.Location.LocationName;
          }

          // Default order type
          if (this.DeliveryOrTakeawayItems != null && this.DeliveryOrTakeawayItems.length > 0) {
            this.DeliveryOrTakeaway = this.DeliveryOrTakeawayItems[0];
          }

          this.getStartDates(true);
          this.getUserData();
          this.productFlow = false;
        }
      },
      getPossibleDates(locationId = null) {
        const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
        const today = new Date();
        const year = today.getFullYear();
        const month = toTwoDigits(today.getMonth() + 1);
        const day = toTwoDigits(today.getDate());
        const todayDate = `${day}-${month}-${year}`;
        const payload = {
          OrderType: this.selectedOrderType,
          StartDate: todayDate,
        };
        locationId !== null ? payload.LocationId = locationId : payload.LocationId = '';
        this.possibleDatesList = [];
        dssRequest.doRequest(
          (response) => {
            console.log('the call for getStartDates bribra on ActivityDetailScreen.vue was successful', response);
            if (_.isEmpty(response.data)) return;
            this.chosenLocation = {};
            if (!_.isEmpty(response.data.AllLocations)) {
              this.allLocations = response.data.AllLocations;
              if (this.allLocations.length > 0) this.chosenLocation = this.allLocations[0];
            } else {
              this.chosenLocation.LocationId = locationId;
            }
            const ordered = {};
            const object = {};
            Object.keys(response.data.Calendar)
              .sort((a, b) => dateConverter(a) - dateConverter(b))
              .forEach((key) => {
                ordered[key] = response.data.Calendar[key];
              });
            this.possibleDatesList = [];
            for (let [index, item] of Object.entries(ordered)) {
              const [day, month, year] = index.split('-');
              index = `${year}-${month}-${day}`;
              this.possibleDatesList.push(index);
            }
            this.selectedDate = this.possibleDatesList[0];
            console.log('Lorenzo this.selectedDate', this.selectedDate);

            function dateConverter(date) {
              const dateParts = date.split('-');
              const dateObject = new Date(
                +dateParts[2],
                dateParts[1] - 1,
                +dateParts[0],
              );
              return dateObject;
            }

            this.getBarChart(this.formatDate(this.selectedDate), 'myChart');
          },
          (error) => {
            console.log('the call for getStartDates on ActivityDetailScreen.vue was not successful', error);
          },
          'getStartDates',
          this.$store.getters.getChosenEvent,
          payload,
          600000,
          false,
        );
      },
      returnRightDescription() {
        return this.eventDetails.Description.replace(/\n/g, '<br>');
      },
      allowedPossibleDatesList(val) {
        return this.possibleDatesList.indexOf(val) !== -1;
      },
      getBarChart(recievedDate, gettingId) {
        if (recievedDate === '') {
          recievedDate = this.getCurrentDate();
        }
        if (this.selectedOrderType === '') {

        }
        if (this.eventDetails.Type === 'OrderEvent' && this.selectedOrderType === '') {
          this.selectedOrderType = this.DeliveryOrTakeawayItems[0];
        }

        // This function is used to get all batches (time-slots) of an event, to show how busy it is between a certain start/end date
        const d = new Date(); // for now
        const x = d.getHours(); // => 9
        const y = d.getMinutes(); // =>  30
        let z = '';
        if (y.toString().length == 1) {
          z = `0${y.toString()}`;
        } else {
          z = y.toString();
        }
        const n = `${x}:${z}`;
        const payload = {
          StartTime: String(n),
          EndTime: '00:00',
          StartDate: recievedDate,
          EndDate: recievedDate,
          OrderType: this.selectedOrderType,
          LocationId: this.chosenLocation.LocationId,
        };
        if (payload.StartDate === null || payload.EndDate === null) return;
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call getPlanBoard was successful',
              response,
            );
            this.chartData = response.data;
            // if there's no data the chart won't be visible
            if (!this.chartData.PlanBoard.hasOwnProperty(0)) {
              this.noPlanBoardData = true;
              this.noData = true;
              return;
            }
            let check = false;
            // the data of the chart: y = EventCapacity and x = TimeSlots
            const y = [];
            const x = [];
            for (const [index, item] of Object.entries(this.chartData.PlanBoard[0].TimeSlots)) {
              y.push(item.EventOccupancy);
              x.push(item.Time);
            }
            // a check that if there's an element that has a bigger value then 0
            y.forEach((e) => {
              check = true;
            });
            if (_.isEmpty(this.chartData.PlanBoard) || !check) {
              this.noData = true;
            }
            setTimeout(() => {
              const ctx = document.getElementById(gettingId);
              const barChart = new Chart(ctx, {
                // The type of chart we want to create
                type: 'bar',

                // The data for our dataset
                data: {
                  labels: x,
                  datasets: [{
                    label: recievedDate,
                    backgroundColor: this.$vuetify.theme.primary,
                    borderColor: this.$vuetify.theme.primary,
                    data: y,
                  }],
                },

                // Configuration options go here
                options: {
                  scales: {
                    xAxes: [{
                      display: true,
                      scaleLabel: {
                        display: true,
                      },
                    }],
                    yAxes: [{
                      display: true,
                      ticks: {
                        beginAtZero: true,
                        steps: 0,
                        max: 100,
                        stepSize: this.$store.getters.getMobilePhoneActive ? 25 : 10,
                        callback(tick) {
                          return `${tick.toString()}%`;
                        },
                      },
                    }],
                  },
                },
              });
            }, 10);
          },
          (error) => {
            console.log(
              'The generic call getPlanBoard was not successful',
              error,
            );
          },
          'getPlanBoard',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      getChipData(sendedInfo, item) {
        if (sendedInfo == 'text') {
          if (item.State == 1) return 'NOT_BUSY'; // green
          if (item.State == 2) return 'NORMAL'; // yellow
          return 'ALMOST_FULL'; // red
        }
        if (sendedInfo == 'color') {
          if (item.State == 0) return 'rgba(25, 181, 254, 1)'; // blue
          if (item.State == 1) return 'rgba(0, 230, 64, 0.8)'; // green
          if (item.State == 2) return 'rgba(240, 255, 0, 0.8)'; // yellow
          return 'rgba(240, 52, 52, 0.8)'; // red
        }
        if (sendedInfo == 'darkModus') {
          if (item.Occupancy < 0.25) return true;
          if (item.Occupancy < 0.5) return false;
          return true;
        }
      },
      callingSecondFunctionForRentalBar(sendingFrom) {
        // calling the function from the start date picker
        if (sendingFrom == 1 && this.chosenStartDate != '') {
          this.getStartBatches(true);
          this.checkForBookButton();
        }
        // calling the function from the start time selection bar
        else if (sendingFrom == 2 && this.rentalStartTime != '') {
          this.checkForBookButton();
          if (this.eventDetails.Type !== 'OrderEvent') this.getEndDates();
        }
        // calling the function from the end date picker
        else if (sendingFrom == 3 && this.chosenEndDate != '') {
          this.checkForBookButton();
          this.getEndBatches();
        }
      },
      getEndDates() {
        const payload = {
          OrderType: this.DeliveryOrTakeaway,
          StartDate: this.chosenStartDate.split('-')
            .reverse()
            .join('-'),
          StartTime: this.rentalStartTime.StartTime,
          OneClickBooking: true,
        };
        if (!_.isEmpty(this.chosenLocation)) {
          payload.LocationId = this.chosenLocation.LocationId;
        }
        if (this.eventDetails.Type === 'Rental') {
          const products = {};
          for (const [key, value] of Object.entries(this.shoppingCart)) {
            Object.assign(products,
              {
                [value.Id]: Number(value.Amount),
              });
          }
          payload.Products = products;
        }
        dssRequest.doRequest(
          (response) => {
            console.log('- Called on ActivityDetailScreen.vue - '
              + 'the call for getEndDates on the event was successful',
              response);
            // Checking for errors
            if (_.isEmpty(response.data.EndDates)) {
              // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_002');
              return;
            }
            if (_.isEmpty(response.data.EndTimes)) {
              // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_004');
              return;
            }
            // for the times and the dates
            this.chosenEndDate = this.formatDate(response.data.DefaultEndDate);

            this.rentalEndTime = response.data.DefaultEndTime;

            this.rentalEndTimes = response.data.EndTimes;
            this.allowedEndDate = [];
            for (let [index, item] of Object.entries(response.data.EndDates)) {
              item = item.split('-')
                .reverse()
                .join('-');
              this.allowedEndDate.push(item);
            }
            // tickets
            if (this.eventDetails.Type !== 'Rental' && this.eventDetails.Type !== 'OrderEvent') {
              this.shoppingCart = [];
              this.tickets = response.data.Tickets;
              for (const [index, item] of Object.entries(this.tickets)) {
                item.Id = index;
                if (this.shoppingCart.length === 0 && item.Amount === 1) this.shoppingCart.push(item);
              }
            }

            this.checkForBookButton();
          },
          (error) => {
            console.log('- Called on ActivityDetailScreen.vue -'
              + ' the call for getEndDates on the event was not successful',
              error);
          },
          'getEndDates',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      checkProductStatesBeforeConfirm() {
        let allAvailable = true;
        if (this.eventDetails.Type !== 'FlexEvent' &&
          this.eventDetails.Type !== 'Repetitive' &&
          this.eventDetails.Type !== 'Tour' &&
          this.eventDetails.Type !== 'Fixed' &&
          this.eventDetails.Type !== 'OrderEvent' &&
          this.eventDetails.Type !== 'External') {
          for (const [index, item] of Object.entries(this.userOrder.Products)) {
            if (item.State !== 'Available') {
              allAvailable = false;
            }
          }
        }
        if (allAvailable) {
          this.confirmOrderLoading();
        } else {
          this.notAllAvaiblable = true;
        }
      },
      getEndBatches() {
        const payload = {
          OrderType: this.DeliveryOrTakeaway,
          StartDate: this.chosenStartDate.split('-')
            .reverse()
            .join('-'),
          StartTime: this.rentalStartTime.StartTime,
          EndDate: this.chosenEndDate.split('-')
            .reverse()
            .join('-'),
          OneClickBooking: true,
        };
        if (!_.isEmpty(this.chosenLocation)) {
          payload.LocationId = this.chosenLocation.LocationId;
        }
        if (this.eventDetails.Type === 'Rental') {
          const products = {};
          for (const [key, value] of Object.entries(this.shoppingCart)) {
            Object.assign(products,
              {
                [value.Id]: Number(value.Amount),
              });
          }
          payload.Products = products;
        }
        dssRequest.doRequest(
          (response) => {
            console.log('- Called on ActivityDetailScreen.vue - '
              + 'the call for getEndBatches on the event was successful',
              response);
            // Checking for errors
            if (_.isEmpty(response.data.EndTimes)) {
              // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_004');
              return;
            }
            // for the times and the dates
            this.rentalEndTime = response.data.DefaultEndTime;

            this.rentalEndTimes = response.data.EndTimes;
            // tickets
            if (this.eventDetails.Type !== 'Rental' && this.eventDetails.Type !== 'OrderEvent') {
              this.shoppingCart = [];
              this.tickets = response.data.Tickets;
              for (const [index, item] of Object.entries(this.tickets)) {
                item.Id = index;
                if (this.shoppingCart.length === 0 && item.Amount === 1) this.shoppingCart.push(item);
              }
            }
            this.checkForBookButton();
          },
          (error) => {
            console.log('- Called on ActivityDetailScreen.vue -'
              + ' the call for getEndBatches on the event was not successful',
              error);
          },
          'getEndBatches',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      callingForBigMap() {
        console.log('Lorenzo this.activityLocation', this.activityLocation);
        this.genericDialog = true;
        setTimeout(() => {
          const features = [];
          const polylineArray = [];
          const activityDetailMap = this.$refs.activityDetailMapBig.map;
          // to add polyline when it's tour/relay
          if (this.eventDetails.Type === 'Tour' || this.eventDetails.Type === 'Relay') {
            this.eventDetails.RouteAspect.DataFieldTable.PathPoints.forEach((pathPoint, index) => {
              polylineArray.push([
                pathPoint.Longitude,
                pathPoint.Latitude,
              ]);
              let dotFeature = {};

              if (pathPoint.StopNr === -1) {
                dotFeature = MapObject.createDotMarker({
                  longitude: pathPoint.Longitude,
                  latitude: pathPoint.Latitude,
                  data: {},
                }, 'black', 0, '', '');
              } else {
                dotFeature = MapObject.createDotMarker({
                  longitude: pathPoint.Longitude,
                  latitude: pathPoint.Latitude,
                  data: {},
                }, '#3CAEA3', 9, pathPoint.StopNr.toString(), 'white');
              }
              features.push(dotFeature);
            });
            console.log('Lorenzo polylineArray', polylineArray);
            const polylineFeature = MapObject.createPolyline(polylineArray, '#0000FF', 3);

            features.push(polylineFeature);
            activityDetailMap.focusOnPolyline(polylineArray);
          }

          if (this.eventDetails.Type !== 'Tour' && this.eventDetails.Type !== 'Relay') {
            // to add marker
            activityDetailMap.deleteLayer('detailMarker');
            features.push(MapObject.createCategoryMarker(this.activityLocation));
            activityDetailMap.focusOnCoordinate([this.activityLocation.longitude, this.activityLocation.latitude], 20);
          }

          const vectorSource = MapObject.createVectorSource(features);
          const vectorLayer = MapObject.createVectorLayer('detailMarker', vectorSource);
          vectorLayer.setZIndex(100);
          this.$refs.activityDetailMapBig.map.addLayerOnMap(vectorLayer);
        }, 1000);
      },
      getStartBatches(callingForBooking) {
        const [year, month, day] = this.chosenStartDate.split('-');
        const ChosenStartDate = `${day}-${month}-${year}`;
        const payload = {
          OrderType: this.DeliveryOrTakeaway,
          StartDate: ChosenStartDate,
        };
        if (!_.isEmpty(this.chosenLocation)) {
          payload.LocationId = this.chosenLocation.LocationId;
        }
        if (this.eventDetails.Type === 'Rental') {
          const products = {};
          for (const [key, value] of Object.entries(this.shoppingCart)) {
            Object.assign(products,
              {
                [value.Id]: Number(value.Amount),
              });
          }
          payload.Products = products;
        }
        if (callingForBooking) {
          payload.OneClickBooking = true;
          payload.StartTime = this.rentalStartTime.StartTime;
        }
        dssRequest.doRequest(
          (response) => {
            console.log('- Called on ActivityDetailScreen.vue - '
              + 'the call for getStartBatches on the event was successful',
              response);
            if (callingForBooking) {
              // Checking for errors
              if (_.isEmpty(response.data.EndDates) && this.eventDetails.Type !== 'OrderEvent') {
                // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_002');
                return;
              }
              if (_.isEmpty(response.data.StartTimes)) {
                // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_003');
                return;
              }
              if (_.isEmpty(response.data.EndTimes) && this.eventDetails.Type !== 'OrderEvent') {
                // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_004');
                return;
              }
              // for the times and the dates
              if (response.data.hasOwnProperty('DefaultEndDate')) {
                this.chosenEndDate = this.formatDate(response.data.DefaultEndDate);
              }
              this.rentalStartTime = response.data.DefaultStartTime;
              this.rentalEndTime = response.data.DefaultEndTime;
              this.rentalStartTimes = response.data.StartTimes;
              this.rentalEndTimes = response.data.EndTimes;
              this.allowedEndDate = [];
              if (response.data.hasOwnProperty('EndDates')) {
                for (let [index, item] of Object.entries(response.data.EndDates)) {
                  item = item.split('-')
                    .reverse()
                    .join('-');
                  this.allowedEndDate.push(item);
                }
              }
              // tickets
              if (this.eventDetails.Type !== 'Rental' && this.eventDetails.Type !== 'OrderEvent') {
                this.shoppingCart = [];
                this.tickets = response.data.Tickets;
                for (const [index, item] of Object.entries(this.tickets)) {
                  item.Id = index;
                  if (this.shoppingCart.length === 0 && item.Amount === 1) this.shoppingCart.push(item);
                }
              }
              this.checkForBookButton();
            } else {
              if (_.isEmpty(response.data.ArrivalBatches)) {
                window.EventBus.fire(
                  'activateErrorDialog',
                  this.$translate('CANT_FIND_STARTIME'),
                );
                return;
              }
              if (this.eventDetails.Type === 'Fixed'
                || this.eventDetails.Type === 'Repetitive'
                || this.eventDetails.Type === 'Tour'
                || this.eventDetails.Type === 'OrderEvent') {
                this.rentalStartTimes = [];
                for (const [index, item] of Object.entries(response.data.ArrivalBatches)) {
                  if (item.hasOwnProperty('EndTime')) {
                    item.TotalTime = `${item.StartTime} - ${item.EndTime}`;
                  } else {
                    item.TotalTime = item.StartTime;
                  }
                  this.rentalStartTimes.push(item);
                }
                if (this.eventDetails.Type === 'OrderEvent') {
                  if (response.data.Orderable === 1) {
                    this.DeliveryOrTakeaway = 'Takeaway';
                  } else if (response.data.Orderable === 2) {
                    this.DeliveryOrTakeaway = 'Delivery';
                  }
                }
                this.getUserData();
                if (this.eventDetails.Type == 'OrderEvent') this.stepperSteps = 3;
              } else {
                this.rentalStartTimes = [];
                for (const [index, item] of Object.entries(response.data.ArrivalBatches)) {
                  if (item.hasOwnProperty('EndTime')) {
                    item.TotalTime = `${item.StartTime} - ${item.EndTime}`;
                  } else {
                    item.TotalTime = item.StartTime;
                  }
                  this.rentalStartTimes.push(item);
                }
              }
            }
          },
          (error) => {
            console.log('- Called on ActivityDetailScreen.vue -'
              + ' the call for getStartBatches on the event was not successful',
              error);
          },
          'getStartBatches',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      getStartDates(callingForBooking) {
        const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
        const today = new Date();
        const year = today.getFullYear();
        const month = toTwoDigits(today.getMonth() + 1);
        const day = toTwoDigits(today.getDate());
        const todayDate = `${day}-${month}-${year}`;
        const payload = {
          OrderType: this.DeliveryOrTakeaway,
          StartDate: todayDate,
        };
        if (!_.isEmpty(this.chosenLocation)) {
          payload.LocationId = this.chosenLocation.LocationId;
        }
        if (this.eventDetails.Type === 'Rental') {
          const products = {};
          for (const [key, value] of Object.entries(this.shoppingCart)) {
            Object.assign(products,
              {
                [value.Id]: Number(value.Amount),
              });
          }
          payload.Products = products;
        }
        if (this.chosenStartDate !== '') {
          payload.StartDate = this.chosenStartDate.split('-')
            .reverse()
            .join('-');
        }
        if (callingForBooking) payload.OneClickBooking = true;
        dssRequest.doRequest(
          (response) => {
            console.log('- Called on ActivityDetailScreen.vue - '
              + 'the call for getStartDates on the event was successful',
              response);

            // // Update location list
            // this.allLocations = [];
            // if (response.data.AllLocations !== null) {
            //   this.allLocations = response.data.allLocations;
            //   if (this.allLocations.length > 0) this.chosenLocation
            // }

            // const ordered = {};
            // const object = {};
            // Object.keys(response.data.Calendar)
            //   .sort((a, b) => dateConverter(a) - dateConverter(b))
            //   .forEach((key) => {
            //     ordered[key] = response.data.Calendar[key];
            //   });
            // this.possibleDatesList = [];
            // for (let [index, item] of Object.entries(ordered)) {
            //   const [day, month, year] = index.split('-');
            //   index = `${year}-${month}-${day}`;
            //   this.possibleDatesList.push(index);
            // }
            // this.selectedDate = this.possibleDatesList[0];
            // console.log('Lorenzo this.selectedDate', this.selectedDate);
            // function dateConverter(date) {
            //   const dateParts = date.split('-');
            //   const dateObject = new Date(
            //     +dateParts[2],
            //     dateParts[1] - 1,
            //     +dateParts[0],
            //   );
            //   return dateObject;
            // }
            this.getBarChart(this.formatDate(response.data.DefaultStartDate), 'myChart');
            this.allowedStartDate = [];
            if (callingForBooking) {
              // Checking for errors
              if (_.isEmpty(response.data.StartDates)) {
                // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_001');
                return;
              }
              if (_.isEmpty(response.data.EndDates) && this.eventDetails.Type !== 'OrderEvent') {
                // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_002');
                return;
              }
              if (_.isEmpty(response.data.StartTimes)) {
                // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_003');
                return;
              }
              if (_.isEmpty(response.data.EndTimes) && this.eventDetails.Type !== 'OrderEvent') {
                // window.EventBus.fire('triggerGenericErrorDialog', 'E_GSD_004');
                return;
              }
              // for the times and the dates
              this.chosenStartDate = this.formatDate(response.data.DefaultStartDate);

              this.rentalStartTime = response.data.DefaultStartTime;
              this.rentalStartTimes = response.data.StartTimes;
              this.allowedStartDate = [];
              for (let [index, item] of Object.entries(response.data.StartDates)) {
                item = item.split('-')
                  .reverse()
                  .join('-');
                this.allowedStartDate.push(item);
              }
              this.allowedEndDate = [];
              if (this.eventDetails.Type !== 'OrderEvent') {
                for (let [index, item] of Object.entries(response.data.EndDates)) {
                  item = item.split('-')
                    .reverse()
                    .join('-');
                  this.allowedEndDate.push(item);
                }
                this.rentalEndTime = response.data.DefaultEndTime;
                this.rentalEndTimes = response.data.EndTimes;
                this.chosenEndDate = this.formatDate(response.data.DefaultEndDate);
              }
              // tickets
              if (this.eventDetails.Type !== 'Rental') {
                this.tickets = response.data.Tickets;
                if (this.eventDetails.Type !== 'OrderEvent') this.shoppingCart = [];
                for (const [index, item] of Object.entries(this.tickets)) {
                  item.Id = index;
                  if (this.shoppingCart.length === 0
                    && item.Amount === 1
                    && this.eventDetails.Type !== 'OrderEvent') {
                    this.shoppingCart.push(item);
                  }
                  if (this.DeliveryOrTakeaway === 'Delivery') {
                    if (Object.values(this.tickets).length === 1) this.DeliveryDistance = item;
                  }
                }
              }

              this.checkForBookButton();
            } else {
              for (let [index, item] of Object.entries(response.data.Calendar)) {
                const [day, month, year] = index.split('-');
                index = `${year}-${month}-${day}`;
                this.allowedStartDate.push(index);
              }
            }
            if (this.rentalEndTime === '') {
              this.rentalEndTime = {};
            }
          },
          (error) => {
            console.log('- Called on ActivityDetailScreen.vue - '
              + 'the call for getStartDates on the event was not successful', error);
          },
          'getStartDates',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      returnRightDurationTime() {
        const time = (this.eventDetails.Duration / 60).toFixed(0);
        const hours = (time / 60).toFixed(0);
        const minutes = (time % 60).toFixed(0);
        if (hours != 0 && minutes != 0) return `${hours} ${this.$translate('HOURS')} ${this.$translate('AND')} ${minutes} ${this.$translate('MINUTES')}`;
        if (hours == 0 && minutes != 0) return `${minutes} ${this.$translate('MINUTES')}`;
        if (hours != 0 && minutes == 0) return `${hours} ${this.$translate('HOURS')}`;
      },
      returnRightDay(day) {
        console.log('Lorenzo this.eventDetails21', this.eventDetails);
        if (!this.eventDetails.hasOwnProperty('BatchGroupInfo')) return;
        if (this.eventDetails.BatchGroupInfo.Days.length === 0) return this.$translate('NO_DAYS_AVAILABLE');
        switch (day) {
          case 'Mon':
            return this.$translate('MONDAY');
            break;
          case 'Tue':
            return this.$translate('TUESDAY');
            break;
          case 'Wed':
            return this.$translate('WEDNESDAY');
            break;
          case 'Thu':
            return this.$translate('THURSDAY');
            break;
          case 'Fri':
            return this.$translate('FRIDAY');
            break;
          case 'Sat':
            return this.$translate('SATURDAY');
            break;
          case 'Sun':
            return this.$translate('SUNDAY');
            break;
        }
      },
      goToEventHomepage() {
        if (this.$store.getters.getParentEventId !== '') {
          this.$router.push({
            path: '/' + store.getters.getRegion + '/' + 'event=' + this.$store.getters.getParentEventId,
          });
          this.$store.commit('setChosenEvent', this.$store.getters.getParentEventId);
          this.$store.commit('setParentEventId', '');
          this.getEventDetails();
        } else {
          if (this.$store.getters.getSelectedTheme.hasOwnProperty('EventId')) {
            this.$store.commit('setUserGoesBackToHomepage', true);
          }
          this.$router.push({
            name: 'Homepage',
            params: {
              account_id: this.$store.getters.getRegion,
            },
          });
        }
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
      },
      roundPrice(price) {
        return Number(price)
          .toFixed(2)
          .replace('.', ',');
      },
      returnPercentageOfPrice(item) {
        return (`${item * 100}%`);
      },
      checkIfUserIsLoggedIn() {
        if (!this.priceCategoriesOrProducts) {
          for (const [index, item] of Object.entries(this.shoppingCart)) {
            item.Picture = this.eventDetails.Picture;
          }
        }
        if (this.$store.getters['auth/userName'] == '') {
          this.shoppingCart.TotalPrice = this.totalPrice;
          this.$store.commit('setShoppingCart', this.shoppingCart);
          this.$store.commit('setGoToAfterLoginOrRegister', `event:${this.$store.getters.getChosenEvent}`);
          this.goToLogin();
        } else {
          this.stepperSteps = 1;
          this.getUserData();
          this.productFlow = false;

          if (this.eventDetails.Type === 'Rental' || this.eventDetails.Type === 'OrderEvent') {
            if (this.allLocations != null && this.allLocations.length > 0) {
              this.chosenLocation = this.allLocations[0];
            } else {
              // Use default location to get start dates
              this.chosenLocation.LocationId = this.eventDetails.LocationId;
              this.chosenLocation.LocationName = this.eventDetails.Location.LocationName;
            }

            // Default order type
            this.DeliveryOrTakeaway = this.DeliveryOrTakeawayItems[0];

            this.getStartDates(true);
          }
          this.scrollToSendingPostion(380, 0);
          this.checkForBookButton();
        }
      },
      checkForProduct(product) {
        let x = false;
        let foundProduct = {};
        if (Object.keys(product.ChosenProduct).length == Object.keys(product.ItemDef).length) {
          const ordered = {};
          const ordered2 = {};
          Object.keys(product.ChosenProduct)
            .sort()
            .forEach((key) => {
              ordered[key] = product.ChosenProduct[key];
            });
          for (const [index, item] of Object.entries(product.Items)) {
            Object.keys(item.ItemDefs)
              .sort()
              .forEach((key) => {
                ordered2[key] = item.ItemDefs[key];
              });
            if (JSON.stringify(ordered2) === JSON.stringify(ordered)) {
              foundProduct = item;
              x = true;
              if (foundProduct.Capacity > 0) {
                product.DisabledButton = false;
              } else {
                product.DisabledButton = true;
              }
            } else {
              product.DisabledButton = true;
            }
          }
          foundProduct.ParentId = product.Id;
          this.foundProductInSearch = foundProduct;
        } else {
          product.DisabledButton = true;
        }
        if (!_.isEmpty(foundProduct)) {
          product.SelectionPrice = foundProduct.Price;
        }
      },
      acceptAge(item) {
        this.forAgeAbove17Product = item;
        this.forAgeAbove17 = true;
      },
      checkTickets(item, addProduct) {
        if (!item.hasOwnProperty('Picture')) {
          item.Picture = this.eventDetails.Picture;
        }
        this.forAgeAbove17 = false;
        if (addProduct) {
          if (this.eventDetails.Type === 'Rental'
            && item.hasOwnProperty('Capacity')
            && item.Amount !== item.Capacity
            || this.eventDetails.Type === 'OrderEvent'
            && item.hasOwnProperty('Capacity')
            && item.Amount !== item.Capacity) {
            item.Amount++;
          }
          if (item.hasOwnProperty('MaxAmount') && item.Amount !== item.MaxAmount) item.Amount++;
        }
        // add to shoppingCart
        if (item.Amount > 0) {
          // check if shoppingCart is not empty
          if (!_.isEmpty(this.shoppingCart)) {
            let x = false;
            this.shoppingCart.forEach((element) => {
              // check if Item is already in the shoppingCart
              if (element.Id == item.Id) {
                x = true;
                element.Amount = item.Amount;
              }
            });
            if (x == false) {
              this.shoppingCart.push(item);
            }
          }
          // push when shoppingCart is empty
          else {
            this.shoppingCart.push(item);
          }
          if (this.$store.getters.getMobilePhoneActive && this.eventDetails.Type == 'OrderEvent') {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('ADD_TO_CARD'),
            );
          }
        }
        // remove from shoppingCart
        else if (item.Amount > 0) {
          this.shoppingCart.forEach((element) => {
            // search for item in the array
            if (element.Id == item.Id) {
              element.Amount = item.Amount;
            }
          });
        } else {
          this.shoppingCart.forEach((element) => {
            // search for item in the array
            if (element.Id == item.Id) {
              // remove element when amount is 0
              this.shoppingCart.splice(this.shoppingCart.indexOf(element), 1);
            }
          });
        }
        // count items in shoppingCart and calculate the total price
        this.totalPrice = 0;
        this.shoppingCartTotal = 0;
        this.shoppingCart.forEach((element) => {
          element.Subtotal = Number(element.Amount) * Number(element.Price);
          this.shoppingCartTotal += element.Amount;
        });
        this.shoppingCart.forEach((element) => {
          this.totalPrice += element.Subtotal;
        });
        this.totalPrice = this.totalPrice.toFixed(2);
        this.checkForBookButton();
      },
      searchForProduct(product) {
        const ordered = {};
        const ordered2 = {};
        Object.keys(product.ChosenProduct)
          .sort()
          .forEach((key) => {
            ordered[key] = product.ChosenProduct[key];
          });
        for (const [index, item] of Object.entries(product.Items)) {
          Object.keys(item.ItemDefs)
            .sort()
            .forEach((key) => {
              ordered2[key] = item.ItemDefs[key];
            });
          if (JSON.stringify(ordered2) === JSON.stringify(ordered)) {
            item.Name = product.Name;
            item.Amount = 1;
            item.Picture = product.Picture;
            item.ParentId = product.Id;
            product = item;
            break;
          }
        }
        const finalProduct = _.cloneDeep(product);
        // check if shoppingCart is empty
        if (!_.isEmpty(this.shoppingCart)) {
          let x = false;
          this.shoppingCart.forEach((element) => {
            // if item is already in the shoppingCart
            if (element.Id == finalProduct.Id) {
              x = true;
              element.Amount = Number(element.Amount) + Number(finalProduct.Amount);
            }
          });
          // if item is not in the shoppingCart
          if (!x) {
            this.shoppingCart.push(finalProduct);
          }
        }
        // if shoppingCart is not empty
        else {
          this.shoppingCart.push(finalProduct);
        }
        // if(this.$store.getters.getMobilePhoneActive){
        //   window.EventBus.fire(
        //     "activateSnackBar",
        //     this.$translate('ADD_TO_CARD')
        //   );
        // }
        // count items in shoppingCart and calculate the total price
        this.totalPrice = 0;
        this.shoppingCartTotal = 0;
        this.shoppingCart.forEach((element) => {
          element.Subtotal = Number(element.Amount) * Number(element.Price);
          this.shoppingCartTotal += element.Amount;
        });
        this.shoppingCart.forEach((element) => {
          this.totalPrice += element.Subtotal;
        });
        this.totalPrice = this.totalPrice.toFixed(2);
        product.ChosenProduct = {};
      },
      getNextThreeMonthsFromToday() {
        this.currentDaysToSend += 90;
        // This function is called to return the week after today for getCalendar
        const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
        const today = new Date();
        today.setDate(today.getDate() + this.currentDaysToSend);
        const year = today.getFullYear();
        const month = toTwoDigits(today.getMonth() + 1);
        const day = toTwoDigits(today.getDate());
        this.currentDaysToSend = 0;
        return `${day}-${month}-${year}`;
      },
      updateUser() {
        const payload = {
          FirstName: this.userInputs[11],
          LastName: this.userInputs[12],
          PhoneNumber: this.userInputs[19],
          City: this.userInputs[17],
          Street: this.userInputs[14],
          Nr: this.userInputs[15],
        };
        payload.FunctionId = 'UserFunctionLibrary::updateUser';
        dssRequest.doRequest(
          (response) => {
            console.log('- Called on AcitivtyDetailScreen.vue - '
              + 'The generic call updateUser on CurrentAccountId was successful',
              response);
          },
          (error) => {
            console.log('- Called on AcitivtyDetailScreen.vue - '
              + 'The generic call updateUser on CurrentAccountId was not successful',
              error);
          },
          'updateUser',
          this.$store.getters['auth/userName'],
          payload,
        );
      },
      getUserData() {
        const payload = {
          RelationType: 'User',
          Id: store.getters['auth/userName'],
          Types: {
            User: 'User',
          },
          StructuredReply: true,
        };
        dssRequest.doRequest(
          (response) => {
            console.log('The call for getUserData was successful', response);
            this.userInputs = response.data.UserData.User.celldata[0];
            if (this.userInputs[19] == '' || this.userInputs[17] == '' || this.userInputs[14] == '' || this.userInputs[15] == '') {
              this.saveUserData = true;
            }
            this.checkForBookButton();
          },
          (error) => {
            console.log('The call for getUserData was not successful', error);
          },
          'getUserData',
          this.$store.getters['auth/userName'],
          payload,
          600000,
          false,
        );
      },
      LoginCheckAndRemoveSheet() {
        // checks if user is logged in and closes the sheet and closes the map
        this.sheet = false;
        this.checkIfUserIsLoggedIn();
        this.showNav = false;
        this.showMap = false;
      },
      closeMap() {
        // closes map and checks if user is logged in
        this.showMap = false;
        this.checkIfUserIsLoggedIn();
      },
      goToNewEvent(EventId) {
        console.log('Lorenzo EventId', EventId);
        this.$router.push({
          path: '/' + store.getters.getRegion + '/' + 'event=' + EventId,
        });
        this.$store.commit('setParentEventId', this.$store.getters.getChosenEvent);
        this.$store.commit('setChosenEvent', EventId);
        this.getEventDetails();
      },
      goTo(page) {
        // window.EventBus.showPage(page);
        this.$router.push({
          name: page,
          params: 'component',
        });
      },
      confirmOrder() {
        const payload = {
          Runtime: true,
          OrderId: this.userOrder.OrderId,
        };
        dssRequest.doRequest(
          (response) => {
            console.log('The call for confirmOrder was successful', response);
            if (
              response.data.hasOwnProperty('PaymentId')
              && response.data.hasOwnProperty('PaymentUrl')
            ) {
              this.$store.commit('setTripFormPaymentId', response.data.PaymentId);
              if (this.userOrder.OrderTotalPrice !== '0') {
                const path = response.data.PaymentUrl;
                window.location = path;
              } else {
                // this.goTo("MainEventInfo");
                // this.$store.commit("setWebStepId", 2);
              }
            } else {
              this.$store.commit('setOrderId', this.userOrder.OrderId);
              console.log('confirmed tirp without payment');
              this.goTo('TripOrderReady');
            }
          },
          (error) => {
            console.log('The call for confirmOrder was not successful', error);
          },
          'confirmOrder',
          this.$store.getters['auth/userName'],
          payload,
        );
      },
      confirmOrderLoading() {
        if (this.userOrder.OrderTotalPrice !== 0) {
        } else if (this.userOrder.OrderTotalPrice == 0) {
          setTimeout(() => {
            this.userOrder = {};
            this.goTo('TripList');
          }, 5000);
          return;
        }
        setTimeout(() => {
          this.confirmOrder();
        }, 10);
      },
      Get(url) {
        const Httpreq = new XMLHttpRequest(); // a new request
        Httpreq.open('GET', url, false);
        Httpreq.send(null);
        return Httpreq.responseText;
      },
      cancelOrder() {
        const payload = {
          OrderId: this.userOrder.OrderId,
        };
        this.loading = false;
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call cancelOrder was successful',
              response,
            );
            this.stepperSteps = 1;
            this.checkForBookButton();
            this.userOrder = {};
          },
          (error) => {
            console.log(
              'The generic call cancelOrder was not successful',
              error,
            );
          },
          'cancelOrder',
          this.$store.getters['auth/userName'],
          payload,
        );
      },
      bookBatch() {
        const datesAndTimes = {
          StartDate: this.chosenStartDate,
          StartTime: this.rentalStartTime,
          EndTime: this.rentalEndTime,
          EndDate: this.chosenEndDate,
        };
        if (this.checkbox) this.updateUser();

        if (this.DeliveryOrTakeaway === 'Delivery') {
          const json_obj = JSON.parse(this.Get(`https://nominatim.openstreetmap.org/search?q=${this.userInputs[15]}+${this.userInputs[14]},+${this.userInputs[17]}&format=json&polygon=1&addressdetails=1`));
          if (!_.isEmpty(json_obj)) {
            const { lat } = json_obj[0];
            const { lon } = json_obj[0];
            this.$store.commit('setUserOrderLon', lon);
            this.$store.commit('setUserOrderLat', lat);
            this.userInputs.Longitude = Number(this.$store.getters.getUserOrderLon);
            this.userInputs.Latitude = Number(this.$store.getters.getUserOrderLat);
          } else {
            this.locationNotFound = true;
            return;
          }
        }
        const payload = BookObject.objectDefinition(
          this.DeliveryOrTakeaway,
          this.userInputs,
          this.eventDetails,
          this.shoppingCart,
          datesAndTimes,
          this.DeliveryDistance,
          this.remark,
          this.chosenLocation,
        );
        this.noBatch = true;
        this.loading = true;
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call book was successful',
              response,
            );
            response.data.OrderTotalPrice = response.data.OrderTotalPrice.toFixed(2);
            this.stepperSteps = 2;
            this.userDetails = payload.AddressInfo;
            this.userOrder = response.data;
            this.scrollToSendingPostion(380, 0);
            if (this.eventDetails.Type !== 'Rental'
              && this.eventDetails.Type !== 'OrderEvent') {
              for (const [index, item] of Object.entries(response.data.Order)) {
                item.ProductPicture = this.shoppingCart[0].Picture;
              }
            }
          },
          (error) => {
            this.noBatch = false;
            this.loading = false;
            console.log(
              'The generic call bookBatch (book) was not successful',
              error,
            );
            if (error.data.ErrorCode === 'E_BK_001') {
              this.batchErrorMSG = this.$translate('E_BK_001');
            } else if (error.data.ErrorCode === 'E_BK_002') {
              this.batchErrorMSG = this.$translate('E_BK_002');
            } else if (error.data.ErrorCode === 'E_CP_001') {
              this.batchErrorMSG = this.$translate('E_CP_001');
            } else if (error.data.ErrorCode === 'E_CP_002') {
              this.batchErrorMSG = this.$translate('E_CP_002');
            } else if (error.data.ErrorCode === 'E_CP_003') {
              this.batchErrorMSG = this.$translate('E_CP_003');
            } else if (error.data.ErrorCode === 'E_CP_004') {
              this.batchErrorMSG = this.$translate('E_CP_004');
            } else if (error.data.ErrorCode === 'E_CP_005') {
              this.batchErrorMSG = this.$translate('E_CP_005');
            } else if (error.errorMsg === 'E_PO_011') {
              this.batchErrorMSG = this.$translate('E_PO_011');
            } else {
              this.batchErrorMSG = this.$translate('E_00_00');
            }
            window.EventBus.fire(
              'triggerGenericErrorDialog',
              this.batchErrorMSG,
            );
          },
          'book',
          this.$store.getters['auth/userName'],
          payload,
          600000,
          false,
        );
      },
      getCurrentDate() {
        // this function is called to get the current day to call the function getCalendar()
        const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
        const today = new Date();

        const year = today.getFullYear();
        const month = toTwoDigits(today.getMonth() + 1);
        const day = toTwoDigits(today.getDate());
        return `${day}-${month}-${year}`;
      },
      allowedEndDates(val) {
        return this.allowedEndDate.indexOf(val) !== -1;
      },
      allowedStartDates(val) {
        return this.allowedStartDate.indexOf(val) !== -1;
      },
      simpleGetCalendar(type) {
        let payload = {};
        if (type == 'mounted') {
          const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
          const today = new Date();
          const year = today.getFullYear();
          const month = toTwoDigits(today.getMonth() + 1);
          const day = toTwoDigits(today.getDate());
          const todayDate = `${day}-${month}-${year}`;
          payload = {
            StartDate: todayDate,
            LanguageTagId: this.$store.getters.getUserLanguage,
            BatchType: 1,
          };
        } else {
          const [day, month, year] = this.chosenStartDate.split('-');
          const ChosenStartDate = `${year}-${month}-${day}`;
          payload = {
            StartDate: ChosenStartDate,
            LanguageTagId: this.$store.getters.getUserLanguage,
            BatchType: 2,
          };
        }
        dssRequest.doRequest(
          (response) => {
            console.log('the call for getCalendar was successful', response);
            if (type == 'mounted') {
              this.allowedStartDate = [];
              for (let [index, item] of Object.entries(response.data.Calendar)) {
                const [day, month, year] = index.split('-');
                index = `${year}-${month}-${day}`;
                this.allowedStartDate.push(index);
              }
            } else {
              this.allowedEndDate = [];
              for (let [index, item] of Object.entries(response.data.Calendar)) {
                const [day, month, year] = index.split('-');
                index = `${year}-${month}-${day}`;
                this.allowedEndDate.push(index);
              }
            }
          },
          (error) => {
            console.log('the call for getCalendar was not successful', error);
          },
          'getCalendar',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      getCalendar(recievedStartDate) {
        // Returns the calendar for the next 3 months
        const arrayForCheck = [];
        for (const [index, item] of Object.entries(this.eventDetails.PriceCategories)) {
          if (item.hasOwnProperty('Amount') && item.Amount != '0') {
            arrayForCheck.push(item);
          }
        }
        this.calendarList = [];
        const payload = {
          StartDate: recievedStartDate,
          EndDate: this.getNextThreeMonthsFromToday(),
          LanguageTagId: this.$store.getters.getUserLanguage,
        };
        dssRequest.doRequest(
          (response) => {
            console.log('the call for getCalendar was successful', response);
            for (let [index, item] of Object.entries(response.data.Calendar)) {
              const [day, month, year] = index.split('-');
              index = `${year}-${month}-${day}`;
              this.calendarList.push(index);
            }
            this.stepperSteps = 2;
          },
          (error) => {
            console.log('the call for getCalendar was not successful', error);
          },
          'getCalendar',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      toggleFavourite(item) {
        const userId = this.$store.getters['auth/userName'];
        if (userId === '') {
          // User not logged in, go to login page
          this.goTo('Login');
          // this.$store.commit("setSaveFavourite", item.EventId);
        } else {
          let functionCall = '';
          if (item.Favourite) {
            functionCall = 'deleteFavourite';
          } else {
            functionCall = 'addFavourite';
          }
          item.Favourite = !item.Favourite;

          const payload = {
            EventId: Number(item.EventId),
          };
          dssRequest.doRequest(
            (response) => {
              console.log(
                `the call for ${functionCall} was successful`,
                response,
              );
              // this.$store.commit("setSaveFavourite", {});
            },
            (error) => {
              console.log(
                `the call for ${functionCall} was not successful`,
                error,
              );
            },
            functionCall,
            this.$store.getters['auth/userName'],
            payload,
          );
        }
      },
      getFavourites() {
        if (this.$store.getters['auth/userName'] === '') return;
        const payload = {
          Runtime: true,
        };
        dssRequest.doRequest(
          (response) => {
            console.log('the call for getFavourites was successful', response);
            for (const [index, item] of Object.entries(response.data.Favourites)) {
              if (item.EventId == this.eventDetails.EventId) {
                this.eventDetails.Favourite = true;
              } else {
                return;
              }
            }
          },
          (error) => {
            console.log('the call for getFavourites was not successful', error);
          },
          'getFavourites',
          this.$store.getters['auth/userName'],
          payload,
        );
      },
      onResize() {
        this.windowSize = {
          x: window.innerWidth,
          y: window.innerHeight
        };
        this.carouselHeight = 8.1 * window.innerHeight;
      },
      getEventDetails(NotChangingScreens) {
        this.eventDetails = {};
        if (this.$store.getters.getChosenEvent == ''
          || _.isEmpty(this.$store.getters.getChosenEvent)) {
          this.goBackToHome();
          return;
        }
        const payload = {
          LanguageTagId: this.$store.getters.getUserLanguage,
          FullPicture: true,
        };
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call getEventDetailsV2 was successful',
              response,
            );
            response.data.Favourite = false;
            this.eventDetails = response.data;
            if (this.eventDetails.Type === 'Tour') {
              window.EventBus.fire('getTours', true);
              setTimeout(() => {
                for (const [index, item] of Object.entries(this.$store.getters.getTours)) {
                  if (item.TourId == this.eventDetails.EventId) {
                    window.EventBus.fire('showTours', { item });
                  }
                }
              }, 1000);
            }
            if (this.eventDetails.Type !== 'OrderEvent' &&
              this.eventDetails.Type !== 'Rental' &&
              this.eventDetails.Type !== 'Standard') {
              this.getBarChart(this.formatDate(new Date().toISOString()
                .slice(0, 10)), 'myChart');
            }
            if (this.eventDetails.hasOwnProperty('BatchGroupInfo')) {
              this.eventDetails.BatchGroupInfo.Days = this.eventDetails.BatchGroupInfo.Days.split(', ');
              if (this.eventDetails.BatchGroupInfo.Days[0] == 'Sun') {
                const day = this.eventDetails.BatchGroupInfo.Days.shift();
                this.eventDetails.BatchGroupInfo.Days.push(day);
              }
              if (this.eventDetails.Type === 'Rental') {
                this.manageGetBatchGroup();
              }
              if (this.eventDetails.Type === 'Rental' ||
                this.eventDetails.Type === 'FlexEvent') {
                this.simpleGetCalendar('mounted');
                this.getStartDates();
              }
            }
            this.$store.commit(
              'setSelectedEventId',
              this.eventDetails.LocationId,
            );
            this.extraPictures.push(this.eventDetails.PictureUrl);
            for (const [key, value] of Object.entries(
              this.eventDetails.ExtraPictures,
            )) {
              this.extraPictures.push(value);
            }
            if (response.data.Type === 'OrderEvent' || response.data.Type === 'Rental') {
              this.deliveryArray = [];
              for (const [index, item] of Object.entries(this.eventDetails.PriceCategories)) {
                this.deliveryArray.push(item);
              }
              this.eventDetails.DeliveryFee = this.deliveryArray;
              delete this.eventDetails.PriceCategories;
              if (response.data.TakeAwayPossible) this.DeliveryOrTakeawayItems.push('TakeAway');
              if (response.data.DeliveryPossible) this.DeliveryOrTakeawayItems.push('Delivery');
              if (this.DeliveryOrTakeawayItems.length < 2) {
                this.DeliveryOrTakeawayDisabled = true;
                this.DeliveryOrTakeaway = this.DeliveryOrTakeawayItems[0];
              }
              this.selectedOrderType = this.DeliveryOrTakeawayItems[0];
              this.getProducts();
              if (!NotChangingScreens) {
                this.switchContent = false;
              }
            } else {
              this.priceCategoriesOrProducts = false;
              if (!NotChangingScreens) {
                this.switchContent = true;
              }
              if (this.eventDetails.hasOwnProperty('PriceCategories')) {
                for (const [index, item] of Object.entries(response.data.PriceCategories)) {
                  item.Amount = 0;
                  item.Price = item.Price.toFixed(2);
                }
              }
            }
            if (response.data.hasOwnProperty('LocationId')
              && response.data.LocationId !== '') {
              this.getPossibleDates(response.data.LocationId);
            }
            ;
            this.getFavourites();
            this.showCategoriesForDetails();
            this.getLocations();
          },
          (error) => {
            console.log(
              'The generic call getEventDetailsV2 was not successful',
              error,
            );
            if (error.data.ErrorMsg.includes('E_OB_002')) {
              error.data.ErrorCode = 'E_OB_002';
            }
            if (!error.data.hasOwnProperty('ErrorCode')) {
              error.data.ErrorCode = 'E_00_00';
            }
            // window.EventBus.fire(
            //   'triggerGenericErrorDialog',
            //   error.data.ErrorCode,
            // );
          },
          'getEventDetailsV2',
          this.$store.getters.getChosenEvent,
          payload,
          600000,
          false,
        );
      },
      manageGetBatchGroup() {
        const payload = {
          EventId: this.$store.getters.getChosenEvent,
          FunctionId: 'EventFunctionLibrary::getBatchGroups',
        };
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call getBatchGroups was successful',
              response,
            );
            delete response.data.ErrorMsg;
            this.batchGroupList = Object.values(response.data);
          },
          (error) => {
            console.log(
              'The generic call getBatchGroups was not successful',
              error,
            );
            window.EventBus.fire('activateErrorDialog', error.errorMsg);
          },
          'communicateWithDBLibrary',
          appConfig.dss.eventAdminMng,
          payload,
        );
      },
      getProducts() {
        const payload = {};
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call getProducts was successful',
              response,
            );
            this.products = response.data;
            if (!_.isEmpty(this.products.Categories)) {
              this.chosenCategorie = Object.values(this.products.Categories)[0].Name;
              if (_.isEmpty(this.allCategories)) {
                const x = Object.values(this.products.Categories);
                let d = [];
                for (const [index, item] of Object.entries(x)) {
                  if (d.length !== 4) {
                    d.push(item);
                  } else {
                    d = [];
                    d.push(item);
                  }
                  if (d.length === 4
                    || Object.values(this.products.Categories)
                      .indexOf(item) === Object.values(this.products.Categories).length - 1) {
                    this.allCategories.push(d);
                  }
                }
              }
            }
            for (const [index, item] of Object.entries(this.products.Products)) {
              let lowestPrice = 0;
              for (const [innerIndex, innerItem] of Object.entries(item.Items)) {
                if (lowestPrice === 0 || innerItem.Price < lowestPrice) lowestPrice = innerItem.Price;
              }
              item.LowestPrice = lowestPrice;
              item.ParentId = index;
              item.DisabledButton = true;
              item.ChosenProduct = {};
              item.Amount = 0;
              item.Price = item.Price.toFixed(2);
            }
            this.priceCategoriesOrProducts = true;
          },
          (error) => {
            console.log(
              'The generic call getProducts was not successful',
              error,
            );
          },
          'getProductsV2',
          this.$store.getters.getChosenEvent,
          payload,
        );
      },
      goBackToHome() {
        // This function will bring the user back to the homepage
        this.$router.push({
          name: 'Home',
          params: {
            type: 'u',
            account_id: this.$store.getters.getRegion,
          },
        });
      },
      goToLogin() {
        this.$router.push({
          name: 'Login',
          params: {
            type: 'u',
            account_id: store.getters.getRegion,
          },
        });
      },
      showCategoriesForDetails() {
        for (const [index, item] of Object.entries(this.eventDetails.Tags)) {
          if (this.arrayWithCategories.length !== 3) {
            console.log('Lorenzo item.TagGroup', item.TagGroup);
            switch (item.TagGroup) {
              case 'Sights':
                if (this.arrayWithCategories.includes('museum')) break;
                this.arrayWithCategories.push('museum');
                break;
              case 'Activities':
                if (this.arrayWithCategories.includes('museum')) break;
                this.arrayWithCategories.push('accessibility_new');
                break;
              case 'Eating':
                if (this.arrayWithCategories.includes('restaurant')) break;
                this.arrayWithCategories.push('restaurant');
                break;
              case 'Drinking & Nightlife':
                if (this.arrayWithCategories.includes('local_bar')) break;
                this.arrayWithCategories.push('local_bar');
                break;
              case 'Entertainment':
                if (this.arrayWithCategories.includes('casino')) break;
                this.arrayWithCategories.push('casino');
                break;
              case 'Shopping':
                if (this.arrayWithCategories.includes('shopping_bag')) break;
                this.arrayWithCategories.push('shopping_bag');
                break;
              case 'Sleeping':
                if (this.arrayWithCategories.includes('hotel')) break;
                this.arrayWithCategories.push('hotel');
                break;
              case 'Duration':
                if (this.arrayWithCategories.includes('timer')) break;
                this.arrayWithCategories.push('timer');
                break;
              case 'Suitable for':
                if (this.arrayWithCategories.includes('family_restroom')) break;
                this.arrayWithCategories.push('family_restroom');
                break;
              case 'Price':
                if (this.arrayWithCategories.includes('euro')) break;
                this.arrayWithCategories.push('euro');
                break;
              case 'Bus':
                if (this.arrayWithCategories.includes('directions_bus')) break;
                this.arrayWithCategories.push('directions_bus');
                break;
              case 'Ferry':
                if (this.arrayWithCategories.includes('directions_boat')) break;
                this.arrayWithCategories.push('directions_boat');
                break;
              case 'Parking':
                if (this.arrayWithCategories.includes('local_parking')) break;
                this.arrayWithCategories.push('local_parking');
                break;
              default:
                if (this.arrayWithCategories.includes('person')) break;
                this.arrayWithCategories.push('person');
                break;
            }
          }
        }
        console.log('Lorenzo this.arrayWithCategories', this.arrayWithCategories);
      },
      getLocations(object = `${this.$store.getters.getCurrentAccountId}_LSE`) {
        const payload = {
          Densities: [0, 1, 2, 3, 4],
        };
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The call `getLocations` on - ActivityDetailScreen.vue - was successful',
              response,
            );
            if (response.data.hasOwnProperty('Locations')) {
              const receivedMarkers = response.data.Locations;
              receivedMarkers.forEach((arrayElement) => {
                if (arrayElement.LocationId === this.$store.getters.getSelectedEventId) {
                  this.$store.commit('setCenterPointForMap', response.data.CenterPoint);
                  arrayElement.category = arrayElement.MainTag;
                  arrayElement.longitude = arrayElement.Longitude;
                  arrayElement.latitude = arrayElement.Latitude;
                  arrayElement.data = {};
                  delete arrayElement.Longitude;
                  delete arrayElement.Latitude;
                  setTimeout(() => {
                    this.initializeActivityDetailMap(arrayElement);
                  }, 1000);
                }
              });
              this.allMarkers = [];
              this.allMarkers = receivedMarkers;
              this.$store.commit('setNewLocationList', this.allMarkers);
            }
          },
          (error) => {
            console.log(
              'The call `getLocations` on - ActivityDetailScreen.vue - was not successful',
              error,
            );
          },
          'getLocations',
          object,
          payload,
        );
      },
      initializeActivityDetailMap(data) {
        console.log('Lorenzo we are working on the map', data);
        const features = [];
        const polylineArray = [];
        let activityDetailMap = {};
        if (this.eventDetails.Type === 'OrderEvent'
          || this.eventDetails.Type === 'Rental'
          || this.$store.getters.getMobilePhoneActive) {
          activityDetailMap = this.$refs.activityDetailMapWebShop.map;
        } else {
          activityDetailMap = this.$refs.activityDetailMap.map;
        }
        this.activityLocation = data;
        if (this.eventDetails.Type === 'Tour' || this.eventDetails.Type === 'Relay') {
          this.eventDetails.RouteAspect.DataFieldTable.PathPoints.forEach((pathPoint, index) => {
            polylineArray.push([
              pathPoint.Longitude,
              pathPoint.Latitude,
            ]);
            let dotFeature = {};
            if (pathPoint.StopNr === -1) {
              dotFeature = MapObject.createDotMarker({
                longitude: pathPoint.Longitude,
                latitude: pathPoint.Latitude,
                data: {},
              }, 'black', 0, '', '');
            } else {
              dotFeature = MapObject.createDotMarker({
                longitude: pathPoint.Longitude,
                latitude: pathPoint.Latitude,
                data: {},
              }, '#3CAEA3', 9, pathPoint.StopNr.toString(), 'white');
            }
            features.push(dotFeature);
          });
          console.log('Lorenzo polylineArray', polylineArray);
          const polylineFeature = MapObject.createPolyline(polylineArray, '#0000FF', 3);
          features.push(polylineFeature);
          activityDetailMap.focusOnPolyline(polylineArray);
        } else {
          activityDetailMap.deleteLayer('detailMarker');
          features.push(MapObject.createCategoryMarker(data));
          activityDetailMap.focusOnCoordinate([data.longitude, data.latitude], 20);
        }
        const vectorSource = MapObject.createVectorSource(features);
        const vectorLayer = MapObject.createVectorLayer('detailMarker', vectorSource);
        vectorLayer.setZIndex(100);
        if (this.eventDetails.Type === 'OrderEvent'
          || this.eventDetails.Type === 'Rental'
          || this.$store.getters.getMobilePhoneActive) {
          this.$refs.activityDetailMapWebShop.map.addLayerOnMap(vectorLayer);
        } else {
          this.$refs.activityDetailMap.map.addLayerOnMap(vectorLayer);
        }
      },
      // setPolylineColor(state) {
      //   switch (state) {
      //     case 0:
      //       return '#A9A9A9';
      //     case 1:
      //       return '#009933';
      //     case 2:
      //       return '#ffff00';
      //     case 3:
      //       return '#ff8000';
      //     case 4:
      //       return '#ff0000';
      //     default:
      //       return '#A9A9A9';
      //   }
      // },
    },
  };
</script>
<style lang="scss" scoped>
  .optionsCard {
    padding: 1em;
  }

  .backgroundForEventDetails {
    position: relative;
    bottom: 1.5em;
    min-height: 70em;
    background-color: white;
    margin-left: -3.4em;
    margin-right: -3.4em;
  }

  .eventTitle {
    font-size: 2.5em;
  }

  .eventDescription {
    font-size: 20px;
  }

  .descriptionV-card {
    padding-top: 0.5em;
  }

  .locationV-card {
    padding-top: 2em;
  }

  .contactV-card {
    padding-top: 2em;
  }

  .locationV-card p {
    margin-bottom: 0.3em;
  }

  .eventImage {
    height: 25em;
  }

  .eventInfo {
    margin-right: 2em;
  }

  .containerDetails {
    margin-top: 5em;
  }

  .shoppingCartTitle {
    height: 5em;
    width: 100%;
  }

  .toggleProducts {
    cursor: pointer;
    height: 5em;
    width: 50%;
  }

  .toggleContent {
    margin-top: 2em;
    width: 100%;
    margin-bottom: 6em;
  }

  .midSectionDetails {
    width: 80%;
    min-height: 60em;
    margin-bottom: 2em;
    max-width: 1200px;
  }

  .rentalInputDates {
    max-width: 1200px;
    width: 100%;
    border-radius: 2em;
    z-index: 10;
  }

  .shoppingBag {
    margin-left: 2em;
    border-left: 0.1em solid lightgrey;
  }

  .productPrice {
    font-size: 1em;
  }

  .favoriteIcon {
    transform: scale(1, 1);
  }

  .productStyling {
    padding-right: 1em;
    box-shadow: 0px 1px 2px rgb(100, 100, 100) !important;
    margin: 0.5em 0 !important;
  }

  .photoCarousel {
    margin: 1em;
  }

  .plusOrMinusButtonShoppingCart {
    height: 20px !important;
    width: 20px !important;
  }

  .plusOrMinusButton {
    height: 30px !important;
    width: 30px !important;
  }

  .dividerStyle {
    margin-bottom: 1em;
  }

  .buttonGroup {
    padding-top: 1em;
  }

  .shoppingBagContent {
    min-height: 20em;
  }

  .orderListAvatar {
    margin-right: 2em;
  }

  .orderListItem {
    margin: 2em 0;
  }

  .adressStyling {
    margin-bottom: 4px;
  }

  .theme--light.v-expansion-panel--focusable .v-expansion-panel__container:focus {
    background-color: white !important;
  }

  .freeDelivery {
    padding-right: 1em;
    color: rgb(0, 173, 46);
  }

  .sizeForSearchBlock {
    background: none !important;
  }

  .searchBarFlex {
    margin-bottom: 2em;
  }

  .priceOverviewBlocks {
    margin-bottom: 1em;
    padding-right: 4em;
  }

  .hrForPrices {
    border-bottom-left-radius: unset !important;
    border-bottom-right-radius: unset !important;
  }

  .no-click {
    pointer-events: none;
  }

  .backButtonActivityDetails {
    margin-left: -7em !important;
  }

  .backButtonActivityDetails:hover {
    transform: scale(0.8);
  }

  .noData {
    text-align: center;
    z-index: 10;
    margin-top: -9em;
    margin-bottom: 6em;
  }

  .detailsContainer {
    z-index: 0;
    background: none;
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -3.4em;
    margin-bottom: -2em;
  }

  .flexStraight {
    overflow: hidden;
    transform: skew(-9.3deg);
    margin-top: 3em;
    margin-left: 3em;
    margin-right: 3em;
    height: 88%;
    padding-left: 1em;
  }

  .flexLeftBottom {
    margin-right: 3em;
    height: 100%;
  }

  .myChartBigScreenVersion {
    cursor: pointer;
    margin-top: -4em;
  }

  .secondSection {
    max-width: 1000px;
    margin: 0 auto;
    margin-bottom: 4em;
  }

  .secondSectionDetails {
    margin-top: 4em !important;
    max-width: 1000px;
    margin: 0 auto;
    margin-bottom: 4em;
    min-height: 60em;
  }

  .bookingContainer {
    max-width: 1000px !important;
    margin: 0 auto;
    min-height: 50em;
    margin-top: 2em;
  }

  .bookingContainerMobileVersion {
    max-width: 80% !important;
    margin: 0 auto;
    padding-top: 2em;
  }

  .v-list__tile__action-text {
    color: black !important;
    font-size: 1em;
  }

  .listContent {
    height: 7em !important;
  }

  .optionsCard {
    padding: 1em;
  }

  .responsiveContainer {
    width: 80%;
    margin: auto;
  }

  .chart-container {
    position: relative;
    margin: auto;
    width: 80vw;
  }

  .lineUnderTitleHR {
    margin-bottom: 1em;
    height: 0.5em;
    width: 100%;
  }

  .lineUnderTitle {
    margin: 1.5em 0 3em 0;
    height: 0.5em;
    width: 80%;
  }

  .btnback {
    width: 4em;
  }

  .loadingBar {
    width: 20%;
  }

  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .paddingForTitle {
    padding-top: 1.5em;
  }

  .ticketAmount {
    font-size: 22px;
    margin-top: -0.1em;
    margin: 0 0.5em;
    padding: 2px;
  }

  .categoryBlock {
    border-radius: 3em;
    height: 5em;
    text-align: center;
    width: 20%;
    cursor: pointer;
  }

  .favoriteText {
    color: grey;
    text-align: center;
  }

  .favoriteTextNew {
    color: grey;
    text-align: center;
    margin-bottom: 0 !important;
    margin-top: 0.5em;
  }

  .favoriteBlock {
    padding: 0.5em;
    background-color: white;
    border-radius: 25px;
    margin-top: 1em;
    margin-right: 1em;
  }

  .sizeableDescription {
    margin: 0 !important;
    padding: 1em;
    padding-bottom: 2em;
    font-size: 18px;
  }

  .descriptionButton {
    margin-top: -1.5em;
  }

  .carouselBlock {
    border-radius: 15px;
  }

  /*ticket*/
  .ticket {
    cursor: pointer;
    margin-right: -4em;
    margin-bottom: 2em;
    border-radius: 10px;
    margin-top: 2em;
    transform: rotate(-4deg);
    position: relative;
    border: 2px solid black;
    background: white;
    color: white;
    text-align: center;
    display: inline-block;
    padding: 1em 5em;
  }

  .ticket:hover {
    transform: rotate(0deg);
  }

  .ticket:before {
    height: 90px;
    width: 45px;
    content: '';
    position: absolute;
    top: 0.9em;
    top: calc(1.9em - 1px);
    height: 4em;
    width: 1.6em;
    border: 2px solid black;
  }

  .ticket:before {
    left: -3px;
    background: white;
    border-radius: 0 18px 18px 0;
    border-left-color: white;
  }

  .cardForTheMapAndAddress {
    margin-bottom: 4em;
    background-color: #e8e8e8;
    border-radius: 13px;
    overflow: hidden;
  }

  .clickToOpen {
    margin: 0 !important;
    text-align: center;
    color: grey;
  }

  .btnBackForNotWebshop {
    margin: 1em 0;
    padding: 1.5em !important;
    font-size: 15px;
    font-weight: bold;
  }

  .divAroundIcon {
    margin-right: 1em;
    display: inline-block;
    padding: 0.5em;
    border-radius: 50%;
  }

  .hoverElement:hover {
    transform: scale(1.5);
  }
</style>
